import { defineComponent as w, computed as R, openBlock as f, createBlock as y, resolveDynamicComponent as ee, normalizeClass as A, unref as u, withCtx as p, renderSlot as S, h as mt, useAttrs as pe, ref as Y, mergeProps as B, createCommentVNode as I, createVNode as D, createElementBlock as C, Fragment as Ce, createTextVNode as P, toDisplayString as T, pushScopeId as pn, popScopeId as hn, createElementVNode as j, isRef as Hn, reactive as yn, getCurrentScope as Wn, onScopeDispose as Kn, getCurrentInstance as Zn, onMounted as Te, nextTick as Jn, watch as gn, onBeforeUnmount as qn, createSlots as re, withModifiers as mn, renderList as he, normalizeProps as J, guardReactiveProps as q, resolveDirective as Xn, withDirectives as Pe, withKeys as ie, vModelText as ed, vModelDynamic as td, normalizeStyle as nd, useCssVars as dd, onUnmounted as rd } from "vue";
import { V as ot, ci as od, bQ as id, bd as ad, a$ as Mt, c9 as Mn, aY as je, ck as sd, cl as ld, bw as ud } from "./VTextarea-a9029832.mjs";
var v = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.SECONDARY = "secondary", e.SECONDARY_WEB = "secondary-web", e.TERTIARY = "tertiary", e.HIGHLIGHT_PLAIN = "highlight-plain", e.ACTIVE_TAB = "active-tab", e.BLURRED = "blurred", e.SPECIAL = "special", e))(v || {}), Q = /* @__PURE__ */ ((e) => (e.OUTLINE = "outline", e.ACTION = "action", e.DEFAULT = "default", e.SECONDARY = "secondary", e.SECONDARY_HIGHLIGHT = "secondary-highlight", e.HIGHLIGHT = "highlight", e.BLURRED = "blurred", e))(Q || {});
const cd = [
  "h1",
  "h2",
  "h2-medium",
  "h3",
  "h4",
  "h5",
  "text-cta",
  "subtitle-1-400",
  "subtitle-1-600",
  "subtitle-2-400",
  "subtitle-2-600",
  "body-1-300",
  "body-1-400",
  "body-1-500",
  "body-1-600",
  "body-2-300",
  "body-2-400",
  "body-2-500",
  "body-2-600",
  "body-3-300",
  "body-3-400",
  "body-3-500",
  "body-3-600",
  "body-4-400"
], $d = /* @__PURE__ */ w({
  props: {
    variant: {
      type: String,
      default: "subtitle-2-400",
      validator: (e) => cd.includes(e) ? !0 : (console.warn(`Invalid typography variant '${e}'`), !1)
    },
    colorClass: {
      type: String,
      default: "copy-primary"
    },
    pointer: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = {
      h1: "h1",
      h2: "h2",
      "h2-medium": "span",
      h3: "h3",
      h4: "h4",
      h5: "h5",
      "text-cta": "span",
      "subtitle-1-400": "span",
      "subtitle-1-600": "span",
      "subtitle-2-400": "span",
      "subtitle-2-600": "span",
      "body-1-300": "span",
      "body-1-400": "span",
      "body-1-500": "span",
      "body-1-600": "span",
      "body-2-300": "span",
      "body-2-400": "span",
      "body-2-500": "span",
      "body-2-600": "span",
      "body-3-300": "span",
      "body-3-400": "span",
      "body-3-500": "span",
      "body-3-600": "span",
      "body-4-400": "span"
    }, d = R(() => t.variant.startsWith("body") || t.variant.startsWith("subtitle") ? t.variant.slice(0, -4) : t.variant);
    return (r, o) => (f(), y(ee(n[t.variant] || n["body-2-500"]), {
      "data-testid": "typography",
      class: A([
        "c-typography",
        `c-typography--${u(d)}`,
        `c-typography--${e.colorClass}`,
        `c-typography--${t.variant}`,
        { "c-typography--pointer": e.pointer },
        { ["c-typography--error"]: e.error },
        { [`c-typography--${u(d)}-m`]: r.$vuetify.display.mobile }
      ])
    }, {
      default: p(() => [
        S(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
const G = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [d, r] of t)
    n[d] = r;
  return n;
}, k = /* @__PURE__ */ G($d, [["__scopeId", "data-v-d52c9e4f"]]), le = /^[a-z0-9]+(-[a-z0-9]+)*$/, Ae = (e, t, n, d = "") => {
  const r = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (r.length < 2 || r.length > 3)
      return null;
    d = r.shift().slice(1);
  }
  if (r.length > 3 || !r.length)
    return null;
  if (r.length > 1) {
    const a = r.pop(), s = r.pop(), l = {
      provider: r.length > 0 ? r[0] : d,
      prefix: s,
      name: a
    };
    return t && !Me(l) ? null : l;
  }
  const o = r[0], i = o.split("-");
  if (i.length > 1) {
    const a = {
      provider: d,
      prefix: i.shift(),
      name: i.join("-")
    };
    return t && !Me(a) ? null : a;
  }
  if (n && d === "") {
    const a = {
      provider: d,
      prefix: "",
      name: o
    };
    return t && !Me(a, n) ? null : a;
  }
  return null;
}, Me = (e, t) => e ? !!((e.provider === "" || e.provider.match(le)) && (t && e.prefix === "" || e.prefix.match(le)) && e.name.match(le)) : !1, bn = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), Oe = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), Se = Object.freeze({
  ...bn,
  ...Oe
}), Ye = Object.freeze({
  ...Se,
  body: "",
  hidden: !1
});
function fd(e, t) {
  const n = {};
  !e.hFlip != !t.hFlip && (n.hFlip = !0), !e.vFlip != !t.vFlip && (n.vFlip = !0);
  const d = ((e.rotate || 0) + (t.rotate || 0)) % 4;
  return d && (n.rotate = d), n;
}
function bt(e, t) {
  const n = fd(e, t);
  for (const d in Ye)
    d in Oe ? d in e && !(d in n) && (n[d] = Oe[d]) : d in t ? n[d] = t[d] : d in e && (n[d] = e[d]);
  return n;
}
function pd(e, t) {
  const n = e.icons, d = e.aliases || /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  function o(i) {
    if (n[i])
      return r[i] = [];
    if (!(i in r)) {
      r[i] = null;
      const a = d[i] && d[i].parent, s = a && o(a);
      s && (r[i] = [a].concat(s));
    }
    return r[i];
  }
  return (t || Object.keys(n).concat(Object.keys(d))).forEach(o), r;
}
function hd(e, t, n) {
  const d = e.icons, r = e.aliases || /* @__PURE__ */ Object.create(null);
  let o = {};
  function i(a) {
    o = bt(
      d[a] || r[a],
      o
    );
  }
  return i(t), n.forEach(i), bt(e, o);
}
function vn(e, t) {
  const n = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return n;
  e.not_found instanceof Array && e.not_found.forEach((r) => {
    t(r, null), n.push(r);
  });
  const d = pd(e);
  for (const r in d) {
    const o = d[r];
    o && (t(r, hd(e, r, o)), n.push(r));
  }
  return n;
}
const yd = {
  provider: "",
  aliases: {},
  not_found: {},
  ...bn
};
function _e(e, t) {
  for (const n in t)
    if (n in e && typeof e[n] != typeof t[n])
      return !1;
  return !0;
}
function Nn(e) {
  if (typeof e != "object" || e === null)
    return null;
  const t = e;
  if (typeof t.prefix != "string" || !e.icons || typeof e.icons != "object" || !_e(e, yd))
    return null;
  const n = t.icons;
  for (const r in n) {
    const o = n[r];
    if (!r.match(le) || typeof o.body != "string" || !_e(
      o,
      Ye
    ))
      return null;
  }
  const d = t.aliases || /* @__PURE__ */ Object.create(null);
  for (const r in d) {
    const o = d[r], i = o.parent;
    if (!r.match(le) || typeof i != "string" || !n[i] && !d[i] || !_e(
      o,
      Ye
    ))
      return null;
  }
  return t;
}
const vt = /* @__PURE__ */ Object.create(null);
function gd(e, t) {
  return {
    provider: e,
    prefix: t,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function X(e, t) {
  const n = vt[e] || (vt[e] = /* @__PURE__ */ Object.create(null));
  return n[t] || (n[t] = gd(e, t));
}
function it(e, t) {
  return Nn(t) ? vn(t, (n, d) => {
    d ? e.icons[n] = d : e.missing.add(n);
  }) : [];
}
function md(e, t, n) {
  try {
    if (typeof n.body == "string")
      return e.icons[t] = { ...n }, !0;
  } catch {
  }
  return !1;
}
let ue = !1;
function In(e) {
  return typeof e == "boolean" && (ue = e), ue;
}
function Md(e) {
  const t = typeof e == "string" ? Ae(e, !0, ue) : e;
  if (t) {
    const n = X(t.provider, t.prefix), d = t.name;
    return n.icons[d] || (n.missing.has(d) ? null : void 0);
  }
}
function bd(e, t) {
  const n = Ae(e, !0, ue);
  if (!n)
    return !1;
  const d = X(n.provider, n.prefix);
  return md(d, n.name, t);
}
function vd(e, t) {
  if (typeof e != "object")
    return !1;
  if (typeof t != "string" && (t = e.provider || ""), ue && !t && !e.prefix) {
    let r = !1;
    return Nn(e) && (e.prefix = "", vn(e, (o, i) => {
      i && bd(o, i) && (r = !0);
    })), r;
  }
  const n = e.prefix;
  if (!Me({
    provider: t,
    prefix: n,
    name: "a"
  }))
    return !1;
  const d = X(t, n);
  return !!it(d, e);
}
const Cn = Object.freeze({
  width: null,
  height: null
}), On = Object.freeze({
  ...Cn,
  ...Oe
}), Nd = /(-?[0-9.]*[0-9]+[0-9.]*)/g, Id = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function Nt(e, t, n) {
  if (t === 1)
    return e;
  if (n = n || 100, typeof e == "number")
    return Math.ceil(e * t * n) / n;
  if (typeof e != "string")
    return e;
  const d = e.split(Nd);
  if (d === null || !d.length)
    return e;
  const r = [];
  let o = d.shift(), i = Id.test(o);
  for (; ; ) {
    if (i) {
      const a = parseFloat(o);
      isNaN(a) ? r.push(o) : r.push(Math.ceil(a * t * n) / n);
    } else
      r.push(o);
    if (o = d.shift(), o === void 0)
      return r.join("");
    i = !i;
  }
}
const Cd = (e) => e === "unset" || e === "undefined" || e === "none";
function Od(e, t) {
  const n = {
    ...Se,
    ...e
  }, d = {
    ...On,
    ...t
  }, r = {
    left: n.left,
    top: n.top,
    width: n.width,
    height: n.height
  };
  let o = n.body;
  [n, d].forEach((m) => {
    const b = [], M = m.hFlip, H = m.vFlip;
    let x = m.rotate;
    M ? H ? x += 2 : (b.push(
      "translate(" + (r.width + r.left).toString() + " " + (0 - r.top).toString() + ")"
    ), b.push("scale(-1 1)"), r.top = r.left = 0) : H && (b.push(
      "translate(" + (0 - r.left).toString() + " " + (r.height + r.top).toString() + ")"
    ), b.push("scale(1 -1)"), r.top = r.left = 0);
    let _;
    switch (x < 0 && (x -= Math.floor(x / 4) * 4), x = x % 4, x) {
      case 1:
        _ = r.height / 2 + r.top, b.unshift(
          "rotate(90 " + _.toString() + " " + _.toString() + ")"
        );
        break;
      case 2:
        b.unshift(
          "rotate(180 " + (r.width / 2 + r.left).toString() + " " + (r.height / 2 + r.top).toString() + ")"
        );
        break;
      case 3:
        _ = r.width / 2 + r.left, b.unshift(
          "rotate(-90 " + _.toString() + " " + _.toString() + ")"
        );
        break;
    }
    x % 2 === 1 && (r.left !== r.top && (_ = r.left, r.left = r.top, r.top = _), r.width !== r.height && (_ = r.width, r.width = r.height, r.height = _)), b.length && (o = '<g transform="' + b.join(" ") + '">' + o + "</g>");
  });
  const i = d.width, a = d.height, s = r.width, l = r.height;
  let $, c;
  i === null ? (c = a === null ? "1em" : a === "auto" ? l : a, $ = Nt(c, s / l)) : ($ = i === "auto" ? s : i, c = a === null ? Nt($, l / s) : a === "auto" ? l : a);
  const h = {}, g = (m, b) => {
    Cd(b) || (h[m] = b.toString());
  };
  return g("width", $), g("height", c), h.viewBox = r.left.toString() + " " + r.top.toString() + " " + s.toString() + " " + l.toString(), {
    attributes: h,
    body: o
  };
}
const Dd = /\sid="(\S+)"/g, wd = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let Td = 0;
function jd(e, t = wd) {
  const n = [];
  let d;
  for (; d = Dd.exec(e); )
    n.push(d[1]);
  if (!n.length)
    return e;
  const r = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
  return n.forEach((o) => {
    const i = typeof t == "function" ? t(o) : t + (Td++).toString(), a = o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    e = e.replace(
      new RegExp('([#;"])(' + a + ')([")]|\\.[a-z])', "g"),
      "$1" + i + r + "$3"
    );
  }), e = e.replace(new RegExp(r, "g"), ""), e;
}
const Ve = /* @__PURE__ */ Object.create(null);
function Ad(e, t) {
  Ve[e] = t;
}
function Ge(e) {
  return Ve[e] || Ve[""];
}
function at(e) {
  let t;
  if (typeof e.resources == "string")
    t = [e.resources];
  else if (t = e.resources, !(t instanceof Array) || !t.length)
    return null;
  return {
    resources: t,
    path: e.path || "/",
    maxURL: e.maxURL || 500,
    rotate: e.rotate || 750,
    timeout: e.timeout || 5e3,
    random: e.random === !0,
    index: e.index || 0,
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const st = /* @__PURE__ */ Object.create(null), ae = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], be = [];
for (; ae.length > 0; )
  ae.length === 1 || Math.random() > 0.5 ? be.push(ae.shift()) : be.push(ae.pop());
st[""] = at({
  resources: ["https://api.iconify.design"].concat(be)
});
function Sd(e, t) {
  const n = at(t);
  return n === null ? !1 : (st[e] = n, !0);
}
function lt(e) {
  return st[e];
}
const xd = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
};
let It = xd();
function Ed(e, t) {
  const n = lt(e);
  if (!n)
    return 0;
  let d;
  if (!n.maxURL)
    d = 0;
  else {
    let r = 0;
    n.resources.forEach((i) => {
      r = Math.max(r, i.length);
    });
    const o = t + ".json?icons=";
    d = n.maxURL - r - n.path.length - o.length;
  }
  return d;
}
function Ld(e) {
  return e === 404;
}
const kd = (e, t, n) => {
  const d = [], r = Ed(e, t), o = "icons";
  let i = {
    type: o,
    provider: e,
    prefix: t,
    icons: []
  }, a = 0;
  return n.forEach((s, l) => {
    a += s.length + 1, a >= r && l > 0 && (d.push(i), i = {
      type: o,
      provider: e,
      prefix: t,
      icons: []
    }, a = s.length), i.icons.push(s);
  }), d.push(i), d;
};
function zd(e) {
  if (typeof e == "string") {
    const t = lt(e);
    if (t)
      return t.path;
  }
  return "/";
}
const Pd = (e, t, n) => {
  if (!It) {
    n("abort", 424);
    return;
  }
  let d = zd(t.provider);
  switch (t.type) {
    case "icons": {
      const o = t.prefix, a = t.icons.join(","), s = new URLSearchParams({
        icons: a
      });
      d += o + ".json?" + s.toString();
      break;
    }
    case "custom": {
      const o = t.uri;
      d += o.slice(0, 1) === "/" ? o.slice(1) : o;
      break;
    }
    default:
      n("abort", 400);
      return;
  }
  let r = 503;
  It(e + d).then((o) => {
    const i = o.status;
    if (i !== 200) {
      setTimeout(() => {
        n(Ld(i) ? "abort" : "next", i);
      });
      return;
    }
    return r = 501, o.json();
  }).then((o) => {
    if (typeof o != "object" || o === null) {
      setTimeout(() => {
        o === 404 ? n("abort", o) : n("next", r);
      });
      return;
    }
    setTimeout(() => {
      n("success", o);
    });
  }).catch(() => {
    n("next", r);
  });
}, _d = {
  prepare: kd,
  send: Pd
};
function Ud(e) {
  const t = {
    loaded: [],
    missing: [],
    pending: []
  }, n = /* @__PURE__ */ Object.create(null);
  e.sort((r, o) => r.provider !== o.provider ? r.provider.localeCompare(o.provider) : r.prefix !== o.prefix ? r.prefix.localeCompare(o.prefix) : r.name.localeCompare(o.name));
  let d = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((r) => {
    if (d.name === r.name && d.prefix === r.prefix && d.provider === r.provider)
      return;
    d = r;
    const o = r.provider, i = r.prefix, a = r.name, s = n[o] || (n[o] = /* @__PURE__ */ Object.create(null)), l = s[i] || (s[i] = X(o, i));
    let $;
    a in l.icons ? $ = t.loaded : i === "" || l.missing.has(a) ? $ = t.missing : $ = t.pending;
    const c = {
      provider: o,
      prefix: i,
      name: a
    };
    $.push(c);
  }), t;
}
function Dn(e, t) {
  e.forEach((n) => {
    const d = n.loaderCallbacks;
    d && (n.loaderCallbacks = d.filter((r) => r.id !== t));
  });
}
function Rd(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const t = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!t.length)
      return;
    let n = !1;
    const d = e.provider, r = e.prefix;
    t.forEach((o) => {
      const i = o.icons, a = i.pending.length;
      i.pending = i.pending.filter((s) => {
        if (s.prefix !== r)
          return !0;
        const l = s.name;
        if (e.icons[l])
          i.loaded.push({
            provider: d,
            prefix: r,
            name: l
          });
        else if (e.missing.has(l))
          i.missing.push({
            provider: d,
            prefix: r,
            name: l
          });
        else
          return n = !0, !0;
        return !1;
      }), i.pending.length !== a && (n || Dn([e], o.id), o.callback(
        i.loaded.slice(0),
        i.missing.slice(0),
        i.pending.slice(0),
        o.abort
      ));
    });
  }));
}
let Bd = 0;
function Fd(e, t, n) {
  const d = Bd++, r = Dn.bind(null, n, d);
  if (!t.pending.length)
    return r;
  const o = {
    id: d,
    icons: t,
    callback: e,
    abort: r
  };
  return n.forEach((i) => {
    (i.loaderCallbacks || (i.loaderCallbacks = [])).push(o);
  }), r;
}
function Qd(e, t = !0, n = !1) {
  const d = [];
  return e.forEach((r) => {
    const o = typeof r == "string" ? Ae(r, t, n) : r;
    o && d.push(o);
  }), d;
}
var Yd = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function Vd(e, t, n, d) {
  const r = e.resources.length, o = e.random ? Math.floor(Math.random() * r) : e.index;
  let i;
  if (e.random) {
    let N = e.resources.slice(0);
    for (i = []; N.length > 1; ) {
      const F = Math.floor(Math.random() * N.length);
      i.push(N[F]), N = N.slice(0, F).concat(N.slice(F + 1));
    }
    i = i.concat(N);
  } else
    i = e.resources.slice(o).concat(e.resources.slice(0, o));
  const a = Date.now();
  let s = "pending", l = 0, $, c = null, h = [], g = [];
  typeof d == "function" && g.push(d);
  function m() {
    c && (clearTimeout(c), c = null);
  }
  function b() {
    s === "pending" && (s = "aborted"), m(), h.forEach((N) => {
      N.status === "pending" && (N.status = "aborted");
    }), h = [];
  }
  function M(N, F) {
    F && (g = []), typeof N == "function" && g.push(N);
  }
  function H() {
    return {
      startTime: a,
      payload: t,
      status: s,
      queriesSent: l,
      queriesPending: h.length,
      subscribe: M,
      abort: b
    };
  }
  function x() {
    s = "failed", g.forEach((N) => {
      N(void 0, $);
    });
  }
  function _() {
    h.forEach((N) => {
      N.status === "pending" && (N.status = "aborted");
    }), h = [];
  }
  function Gn(N, F, oe) {
    const ge = F !== "success";
    switch (h = h.filter((Z) => Z !== N), s) {
      case "pending":
        break;
      case "failed":
        if (ge || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (F === "abort") {
      $ = oe, x();
      return;
    }
    if (ge) {
      $ = oe, h.length || (i.length ? ze() : x());
      return;
    }
    if (m(), _(), !e.random) {
      const Z = e.resources.indexOf(N.resource);
      Z !== -1 && Z !== e.index && (e.index = Z);
    }
    s = "completed", g.forEach((Z) => {
      Z(oe);
    });
  }
  function ze() {
    if (s !== "pending")
      return;
    m();
    const N = i.shift();
    if (N === void 0) {
      if (h.length) {
        c = setTimeout(() => {
          m(), s === "pending" && (_(), x());
        }, e.timeout);
        return;
      }
      x();
      return;
    }
    const F = {
      status: "pending",
      resource: N,
      callback: (oe, ge) => {
        Gn(F, oe, ge);
      }
    };
    h.push(F), l++, c = setTimeout(ze, e.rotate), n(N, t, F.callback);
  }
  return setTimeout(ze), H;
}
function wn(e) {
  const t = {
    ...Yd,
    ...e
  };
  let n = [];
  function d() {
    n = n.filter((a) => a().status === "pending");
  }
  function r(a, s, l) {
    const $ = Vd(
      t,
      a,
      s,
      (c, h) => {
        d(), l && l(c, h);
      }
    );
    return n.push($), $;
  }
  function o(a) {
    return n.find((s) => a(s)) || null;
  }
  return {
    query: r,
    find: o,
    setIndex: (a) => {
      t.index = a;
    },
    getIndex: () => t.index,
    cleanup: d
  };
}
function Ct() {
}
const Ue = /* @__PURE__ */ Object.create(null);
function Gd(e) {
  if (!Ue[e]) {
    const t = lt(e);
    if (!t)
      return;
    const n = wn(t), d = {
      config: t,
      redundancy: n
    };
    Ue[e] = d;
  }
  return Ue[e];
}
function Hd(e, t, n) {
  let d, r;
  if (typeof e == "string") {
    const o = Ge(e);
    if (!o)
      return n(void 0, 424), Ct;
    r = o.send;
    const i = Gd(e);
    i && (d = i.redundancy);
  } else {
    const o = at(e);
    if (o) {
      d = wn(o);
      const i = e.resources ? e.resources[0] : "", a = Ge(i);
      a && (r = a.send);
    }
  }
  return !d || !r ? (n(void 0, 424), Ct) : d.query(t, r, n)().abort;
}
const Ot = "iconify2", ce = "iconify", Tn = ce + "-count", Dt = ce + "-version", jn = 36e5, Wd = 168;
function He(e, t) {
  try {
    return e.getItem(t);
  } catch {
  }
}
function ut(e, t, n) {
  try {
    return e.setItem(t, n), !0;
  } catch {
  }
}
function wt(e, t) {
  try {
    e.removeItem(t);
  } catch {
  }
}
function We(e, t) {
  return ut(e, Tn, t.toString());
}
function Ke(e) {
  return parseInt(He(e, Tn)) || 0;
}
const xe = {
  local: !0,
  session: !0
}, An = {
  local: /* @__PURE__ */ new Set(),
  session: /* @__PURE__ */ new Set()
};
let ct = !1;
function Kd(e) {
  ct = e;
}
let me = typeof window > "u" ? {} : window;
function Sn(e) {
  const t = e + "Storage";
  try {
    if (me && me[t] && typeof me[t].length == "number")
      return me[t];
  } catch {
  }
  xe[e] = !1;
}
function xn(e, t) {
  const n = Sn(e);
  if (!n)
    return;
  const d = He(n, Dt);
  if (d !== Ot) {
    if (d) {
      const a = Ke(n);
      for (let s = 0; s < a; s++)
        wt(n, ce + s.toString());
    }
    ut(n, Dt, Ot), We(n, 0);
    return;
  }
  const r = Math.floor(Date.now() / jn) - Wd, o = (a) => {
    const s = ce + a.toString(), l = He(n, s);
    if (typeof l == "string") {
      try {
        const $ = JSON.parse(l);
        if (typeof $ == "object" && typeof $.cached == "number" && $.cached > r && typeof $.provider == "string" && typeof $.data == "object" && typeof $.data.prefix == "string" && t($, a))
          return !0;
      } catch {
      }
      wt(n, s);
    }
  };
  let i = Ke(n);
  for (let a = i - 1; a >= 0; a--)
    o(a) || (a === i - 1 ? (i--, We(n, i)) : An[e].add(a));
}
function En() {
  if (!ct) {
    Kd(!0);
    for (const e in xe)
      xn(e, (t) => {
        const n = t.data, d = t.provider, r = n.prefix, o = X(
          d,
          r
        );
        if (!it(o, n).length)
          return !1;
        const i = n.lastModified || -1;
        return o.lastModifiedCached = o.lastModifiedCached ? Math.min(o.lastModifiedCached, i) : i, !0;
      });
  }
}
function Zd(e, t) {
  const n = e.lastModifiedCached;
  if (n && n >= t)
    return n === t;
  if (e.lastModifiedCached = t, n)
    for (const d in xe)
      xn(d, (r) => {
        const o = r.data;
        return r.provider !== e.provider || o.prefix !== e.prefix || o.lastModified === t;
      });
  return !0;
}
function Jd(e, t) {
  ct || En();
  function n(d) {
    let r;
    if (!xe[d] || !(r = Sn(d)))
      return;
    const o = An[d];
    let i;
    if (o.size)
      o.delete(i = Array.from(o).shift());
    else if (i = Ke(r), !We(r, i + 1))
      return;
    const a = {
      cached: Math.floor(Date.now() / jn),
      provider: e.provider,
      data: t
    };
    return ut(
      r,
      ce + i.toString(),
      JSON.stringify(a)
    );
  }
  t.lastModified && !Zd(e, t.lastModified) || Object.keys(t.icons).length && (t.not_found && (t = Object.assign({}, t), delete t.not_found), n("local") || n("session"));
}
function Tt() {
}
function qd(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, Rd(e);
  }));
}
function Xd(e, t) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(t).sort() : e.iconsToLoad = t, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: n, prefix: d } = e, r = e.iconsToLoad;
    delete e.iconsToLoad;
    let o;
    if (!r || !(o = Ge(n)))
      return;
    o.prepare(n, d, r).forEach((a) => {
      Hd(n, a, (s) => {
        if (typeof s != "object")
          a.icons.forEach((l) => {
            e.missing.add(l);
          });
        else
          try {
            const l = it(
              e,
              s
            );
            if (!l.length)
              return;
            const $ = e.pendingIcons;
            $ && l.forEach((c) => {
              $.delete(c);
            }), Jd(e, s);
          } catch (l) {
            console.error(l);
          }
        qd(e);
      });
    });
  }));
}
const er = (e, t) => {
  const n = Qd(e, !0, In()), d = Ud(n);
  if (!d.pending.length) {
    let s = !0;
    return t && setTimeout(() => {
      s && t(
        d.loaded,
        d.missing,
        d.pending,
        Tt
      );
    }), () => {
      s = !1;
    };
  }
  const r = /* @__PURE__ */ Object.create(null), o = [];
  let i, a;
  return d.pending.forEach((s) => {
    const { provider: l, prefix: $ } = s;
    if ($ === a && l === i)
      return;
    i = l, a = $, o.push(X(l, $));
    const c = r[l] || (r[l] = /* @__PURE__ */ Object.create(null));
    c[$] || (c[$] = []);
  }), d.pending.forEach((s) => {
    const { provider: l, prefix: $, name: c } = s, h = X(l, $), g = h.pendingIcons || (h.pendingIcons = /* @__PURE__ */ new Set());
    g.has(c) || (g.add(c), r[l][$].push(c));
  }), o.forEach((s) => {
    const { provider: l, prefix: $ } = s;
    r[l][$].length && Xd(s, r[l][$]);
  }), t ? Fd(t, d, o) : Tt;
};
function tr(e, t) {
  const n = {
    ...e
  };
  for (const d in t) {
    const r = t[d], o = typeof r;
    d in Cn ? (r === null || r && (o === "string" || o === "number")) && (n[d] = r) : o === typeof n[d] && (n[d] = d === "rotate" ? r % 4 : r);
  }
  return n;
}
const nr = /[\s,]+/;
function dr(e, t) {
  t.split(nr).forEach((n) => {
    switch (n.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
function rr(e, t = 0) {
  const n = e.replace(/^-?[0-9.]*/, "");
  function d(r) {
    for (; r < 0; )
      r += 4;
    return r % 4;
  }
  if (n === "") {
    const r = parseInt(e);
    return isNaN(r) ? 0 : d(r);
  } else if (n !== e) {
    let r = 0;
    switch (n) {
      case "%":
        r = 25;
        break;
      case "deg":
        r = 90;
    }
    if (r) {
      let o = parseFloat(e.slice(0, e.length - n.length));
      return isNaN(o) ? 0 : (o = o / r, o % 1 === 0 ? d(o) : 0);
    }
  }
  return t;
}
function or(e, t) {
  let n = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const d in t)
    n += " " + d + '="' + t[d] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + n + ">" + e + "</svg>";
}
function ir(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function ar(e) {
  return 'url("data:image/svg+xml,' + ir(e) + '")';
}
const jt = {
  ...On,
  inline: !1
}, sr = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": !0,
  role: "img"
}, lr = {
  display: "inline-block"
}, Ze = {
  backgroundColor: "currentColor"
}, Ln = {
  backgroundColor: "transparent"
}, At = {
  Image: "var(--svg)",
  Repeat: "no-repeat",
  Size: "100% 100%"
}, St = {
  webkitMask: Ze,
  mask: Ze,
  background: Ln
};
for (const e in St) {
  const t = St[e];
  for (const n in At)
    t[e + n] = At[n];
}
const ve = {};
["horizontal", "vertical"].forEach((e) => {
  const t = e.slice(0, 1) + "Flip";
  ve[e + "-flip"] = t, ve[e.slice(0, 1) + "-flip"] = t, ve[e + "Flip"] = t;
});
function xt(e) {
  return e + (e.match(/^[-0-9.]+$/) ? "px" : "");
}
const Et = (e, t) => {
  const n = tr(jt, t), d = { ...sr }, r = t.mode || "svg", o = {}, i = t.style, a = typeof i == "object" && !(i instanceof Array) ? i : {};
  for (let b in t) {
    const M = t[b];
    if (M !== void 0)
      switch (b) {
        case "icon":
        case "style":
        case "onLoad":
        case "mode":
          break;
        case "inline":
        case "hFlip":
        case "vFlip":
          n[b] = M === !0 || M === "true" || M === 1;
          break;
        case "flip":
          typeof M == "string" && dr(n, M);
          break;
        case "color":
          o.color = M;
          break;
        case "rotate":
          typeof M == "string" ? n[b] = rr(M) : typeof M == "number" && (n[b] = M);
          break;
        case "ariaHidden":
        case "aria-hidden":
          M !== !0 && M !== "true" && delete d["aria-hidden"];
          break;
        default: {
          const H = ve[b];
          H ? (M === !0 || M === "true" || M === 1) && (n[H] = !0) : jt[b] === void 0 && (d[b] = M);
        }
      }
  }
  const s = Od(e, n), l = s.attributes;
  if (n.inline && (o.verticalAlign = "-0.125em"), r === "svg") {
    d.style = {
      ...o,
      ...a
    }, Object.assign(d, l);
    let b = 0, M = t.id;
    return typeof M == "string" && (M = M.replace(/-/g, "_")), d.innerHTML = jd(s.body, M ? () => M + "ID" + b++ : "iconifyVue"), mt("svg", d);
  }
  const { body: $, width: c, height: h } = e, g = r === "mask" || (r === "bg" ? !1 : $.indexOf("currentColor") !== -1), m = or($, {
    ...l,
    width: c + "",
    height: h + ""
  });
  return d.style = {
    ...o,
    "--svg": ar(m),
    width: xt(l.width),
    height: xt(l.height),
    ...lr,
    ...g ? Ze : Ln,
    ...a
  }, mt("span", d);
};
In(!0);
Ad("", _d);
if (typeof document < "u" && typeof window < "u") {
  En();
  const e = window;
  if (e.IconifyPreload !== void 0) {
    const t = e.IconifyPreload, n = "Invalid IconifyPreload syntax.";
    typeof t == "object" && t !== null && (t instanceof Array ? t : [t]).forEach((d) => {
      try {
        // Check if item is an object and not null/array
        (typeof d != "object" || d === null || d instanceof Array || // Check for 'icons' and 'prefix'
        typeof d.icons != "object" || typeof d.prefix != "string" || // Add icon set
        !vd(d)) && console.error(n);
      } catch {
        console.error(n);
      }
    });
  }
  if (e.IconifyProviders !== void 0) {
    const t = e.IconifyProviders;
    if (typeof t == "object" && t !== null)
      for (let n in t) {
        const d = "IconifyProviders[" + n + "] is invalid.";
        try {
          const r = t[n];
          if (typeof r != "object" || !r || r.resources === void 0)
            continue;
          Sd(n, r) || console.error(d);
        } catch {
          console.error(d);
        }
      }
  }
}
const ur = {
  ...Se,
  body: ""
}, O = w({
  // Do not inherit other attributes: it is handled by render()
  inheritAttrs: !1,
  // Set initial data
  data() {
    return {
      // Mounted status
      iconMounted: !1,
      // Callback counter to trigger re-render
      counter: 0
    };
  },
  mounted() {
    this._name = "", this._loadingIcon = null, this.iconMounted = !0;
  },
  unmounted() {
    this.abortLoading();
  },
  methods: {
    abortLoading() {
      this._loadingIcon && (this._loadingIcon.abort(), this._loadingIcon = null);
    },
    // Get data for icon to render or null
    getIcon(e, t) {
      if (typeof e == "object" && e !== null && typeof e.body == "string")
        return this._name = "", this.abortLoading(), {
          data: e
        };
      let n;
      if (typeof e != "string" || (n = Ae(e, !1, !0)) === null)
        return this.abortLoading(), null;
      const d = Md(n);
      if (!d)
        return (!this._loadingIcon || this._loadingIcon.name !== e) && (this.abortLoading(), this._name = "", d !== null && (this._loadingIcon = {
          name: e,
          abort: er([n], () => {
            this.counter++;
          })
        })), null;
      this.abortLoading(), this._name !== e && (this._name = e, t && t(e));
      const r = ["iconify"];
      return n.prefix !== "" && r.push("iconify--" + n.prefix), n.provider !== "" && r.push("iconify--" + n.provider), { data: d, classes: r };
    }
  },
  // Render icon
  render() {
    this.counter;
    const e = this.$attrs, t = this.iconMounted ? this.getIcon(e.icon, e.onLoad) : null;
    if (!t)
      return Et(ur, e);
    let n = e;
    return t.classes && (n = {
      ...e,
      class: (typeof e.class == "string" ? e.class + " " : "") + t.classes.join(" ")
    }), Et({
      ...Se,
      ...t.data
    }, n);
  }
}), cr = (e) => (pn("data-v-ecde0480"), e = e(), hn(), e), $r = /* @__PURE__ */ cr(() => /* @__PURE__ */ j("div", { class: "d-flex icon ml-3 mr-1" }, [
  /* @__PURE__ */ j("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ j("path", {
      d: "M2.24159 2.24159L7 0.270598L11.7584 2.24159L13.7294 7L11.7584 11.7584L7 13.7294L2.24159 11.7584L0.270598 7L2.24159 2.24159Z",
      fill: "#F3C70D",
      stroke: "#E9AD03",
      "stroke-width": "0.5"
    }),
    /* @__PURE__ */ j("path", {
      d: "M8.33625 5.09093V5.98582H5.51416V5.09093H8.33625ZM6.21089 3.91479H7.36785V8.52346C7.36785 8.679 7.39129 8.79832 7.43817 8.88141C7.48717 8.96238 7.55109 9.01778 7.62993 9.04761C7.70876 9.07744 7.79612 9.09235 7.892 9.09235C7.96444 9.09235 8.0305 9.08703 8.09015 9.07637C8.15194 9.06572 8.19882 9.05613 8.23078 9.04761L8.42574 9.95208C8.36395 9.97339 8.27552 9.99683 8.16047 10.0224C8.04754 10.048 7.90905 10.0629 7.74498 10.0671C7.45521 10.0757 7.1942 10.032 6.96196 9.9361C6.72971 9.83809 6.54541 9.68681 6.40905 9.48227C6.27481 9.27772 6.20876 9.02204 6.21089 8.71522V3.91479Z",
      fill: "#E9AD03"
    })
  ])
], -1)), fr = /* @__PURE__ */ w({
  props: {
    mode: {
      type: String,
      default: v.PRIMARY
    },
    iconHeight: {
      type: String,
      default: "16"
    },
    typographyVariant: {
      type: String,
      default: ""
    },
    textColor: {
      type: String,
      default: ""
    },
    noPadding: {
      type: Boolean,
      default: !1
    },
    warning: {
      type: Boolean,
      default: !1
    },
    price: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, n = pe(), d = Y(!1), r = Y(!1), o = R(() => n.plain !== void 0 || n.text !== void 0), i = R(() => n.size !== "x-large"), a = R(() => n.disabled === "" || n.disabled === !0 ? t.mode === v.SPECIAL ? "highlight-panel" : o.value || t.mode === v.TERTIARY ? "copy-secondary-lock" : "copy-primary-lock" : t.textColor ? t.textColor : t.mode === v.HIGHLIGHT_PLAIN ? r.value ? "highlight-color" : d.value ? "button-primary" : "highlight-color" : o.value ? r.value ? "copy-primary" : d.value ? "copy-secondary" : "copy-primary" : t.mode === v.SECONDARY_WEB || t.mode === v.SECONDARY || t.mode === v.BLURRED ? "highlight-color" : t.mode === v.TERTIARY ? "copy-primary" : "cta"), s = () => t.typographyVariant ? t.typographyVariant : t.mode === v.HIGHLIGHT_PLAIN ? "text-cta" : i.value ? o.value || t.mode === v.TERTIARY || t.mode === v.SECONDARY_WEB ? "body-2-500" : "body-2-600" : t.mode === v.TERTIARY || t.mode === v.SECONDARY_WEB ? "body-1-500" : "body-1-600";
    return (l, $) => (f(), y(u(ot), B({
      onMouseenter: $[0] || ($[0] = (c) => d.value = !0),
      onMouseleave: $[1] || ($[1] = (c) => d.value = !1),
      onMousedown: $[2] || ($[2] = (c) => r.value = !0),
      onMouseup: $[3] || ($[3] = (c) => r.value = !1),
      size: "large",
      plain: e.mode === u(v).ACTIVE_TAB || e.mode === u(v).HIGHLIGHT_PLAIN ? !0 : l.$attrs.plain,
      class: [
        "c-button",
        {
          "c-button-default": !u(o) && e.mode !== u(v).HIGHLIGHT_PLAIN
        },
        {
          "c-button-special": !u(o) && e.mode === u(v).SPECIAL
        },
        {
          "c-button-default--secondary": !u(o) && e.mode === u(v).SECONDARY
        },
        {
          "c-button-default--secondary-web": !u(o) && e.mode === u(v).SECONDARY_WEB
        },
        {
          "c-button-default--tertiary": !u(o) && e.mode === u(v).TERTIARY
        },
        {
          "c-button-default--blurred": !u(o) && e.mode === u(v).BLURRED
        },
        {
          "c-button-text": u(o) && e.mode !== u(v).ACTIVE_TAB || e.mode === u(v).HIGHLIGHT_PLAIN
        },
        {
          "c-button-highlight-text": e.mode === u(v).HIGHLIGHT_PLAIN
        },
        {
          "c-button--size-medium": !u(o) && u(n).size === "medium"
        },
        {
          "c-button-default--warning": e.warning
        },
        { "c-button--icon": l.$attrs["append-icon"] || l.$attrs["prepend-icon"] },
        { "pa-0 c-button--no-min-height": e.noPadding }
      ],
      flat: "",
      depressed: "",
      ripple: !1
    }, { ...l.$attrs }), {
      prepend: p(() => [
        l.$attrs["prepend-icon"] && typeof l.$attrs["prepend-icon"] == "string" ? (f(), y(u(O), {
          key: 0,
          color: e.mode !== u(v).HIGHLIGHT_PLAIN ? u(n).disabled === "" || u(n).disabled === !0 ? "rgb(var(--v-theme-copy-primary-lock))" : "rgba(var(--v-theme-copy-primary))" : "inherit",
          "data-testid": "prepend-icon",
          height: `${t.iconHeight}px`,
          icon: l.$attrs["prepend-icon"]
        }, null, 8, ["color", "height", "icon"])) : I("", !0)
      ]),
      append: p(() => [
        l.$attrs["append-icon"] && typeof l.$attrs["append-icon"] == "string" ? (f(), y(u(O), {
          key: 0,
          color: u(n).disabled === "" || u(n).disabled === !0 ? "rgb(var(--v-theme-copy-primary-lock))" : "rgba(var(--v-theme-copy-primary))",
          "data-testid": "append-icon",
          height: `${t.iconHeight}px`,
          icon: l.$attrs["append-icon"]
        }, null, 8, ["color", "height", "icon"])) : I("", !0)
      ]),
      default: p(() => [
        D(k, {
          "data-testid": "typography",
          variant: `${s()}`,
          pointer: "",
          "color-class": u(a)
        }, {
          default: p(() => [
            S(l.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["variant", "color-class"]),
        e.price ? (f(), C(Ce, { key: 0 }, [
          $r,
          D(k, {
            "data-testid": "typography",
            variant: `${s()}`,
            pointer: "",
            "color-class": u(a)
          }, {
            default: p(() => [
              P(T(e.price), 1)
            ]),
            _: 1
          }, 8, ["variant", "color-class"])
        ], 64)) : I("", !0)
      ]),
      _: 3
    }, 16, ["plain", "class"]));
  }
});
const pr = /* @__PURE__ */ G(fr, [["__scopeId", "data-v-ecde0480"]]), hr = /* @__PURE__ */ w({
  props: {
    mode: {
      type: String,
      default: Q.DEFAULT
    },
    iconHeight: {
      type: String,
      default: "20"
    },
    iconColor: {
      type: String,
      default: ""
    },
    isHover: {
      type: Boolean,
      default: !1
    },
    open: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = pe(), d = R(() => n.plain !== void 0 || n.text !== void 0), r = R(() => t.mode === Q.BLURRED ? "c-icon-button--blurred" : d.value ? "c-icon-button--link" : t.mode === Q.ACTION ? t.open ? "c-icon-button--action--open" : "c-icon-button--action" : t.mode === Q.OUTLINE ? t.open ? "c-icon-button--outline--open" : "c-icon-button--outline" : t.mode === Q.SECONDARY ? "c-icon-button--secondary c-icon-button--link" : t.mode === Q.SECONDARY_HIGHLIGHT ? "c-icon-button--secondary-highlight c-icon-button--link" : t.mode === Q.HIGHLIGHT ? "c-icon-button--highlight" : t.isHover ? "c-icon-button--default c-icon-button--default--is-hover" : "c-icon-button--default");
    return (o, i) => (f(), y(u(ot), B({
      icon: "",
      class: ["c-icon-button", u(r)],
      flat: "",
      width: o.$attrs.size === void 0 ? 40 : e.mode === u(Q).ACTION ? 22 : void 0,
      height: o.$attrs.size === void 0 ? 40 : e.mode === u(Q).ACTION ? 22 : void 0,
      size: t.mode === u(Q).ACTION ? "x-small" : "default",
      depressed: "",
      ripple: !1
    }, { ...o.$attrs }), {
      default: p(() => [
        typeof o.$attrs.icon == "string" ? (f(), y(u(O), {
          key: 0,
          color: e.iconColor || "inherit",
          height: `${e.mode === u(Q).ACTION ? 14 : e.iconHeight}px`,
          icon: o.$attrs.icon
        }, null, 8, ["color", "height", "icon"])) : I("", !0)
      ]),
      _: 1
    }, 16, ["class", "width", "height", "size"]));
  }
});
const yr = /* @__PURE__ */ G(hr, [["__scopeId", "data-v-7306f1dc"]]), gr = /* @__PURE__ */ w({
  setup(e) {
    const t = pr, n = yr;
    return (d, r) => (f(), y(ee(d.$attrs.icon ? u(n) : u(t)), null, {
      default: p(() => [
        S(d.$slots, "default")
      ]),
      _: 3
    }));
  }
}), z0 = "data:image/svg+xml;base64,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", P0 = [
  { href: "https://twitter.com/charactr_", icon: "ph:twitter-logo-fill", target: "_blank" },
  { href: "https://www.linkedin.com/company/charactr/", icon: "ph:linkedin-logo-fill", target: "_blank" }
];
var ne = /* @__PURE__ */ ((e) => (e.SUCCESS = "success", e.INFO = "info", e.WARNING = "warning", e.ERROR = "error", e))(ne || {});
const mr = { class: "align-center d-flex ma-0 pa-4 w-100" }, _0 = /* @__PURE__ */ w({
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: ne.SUCCESS
    },
    mobile: {
      type: Boolean,
      default: !1
    },
    description: {
      type: String,
      default: ""
    },
    timeout: {
      type: Number,
      default: 4e3
    },
    dismissable: {
      type: Boolean,
      default: !1
    },
    typography: {
      type: String,
      default: "body-1-400"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, d = R({
      get() {
        return n.modelValue;
      },
      set(i) {
        t("update:modelValue", i);
      }
    }), r = n.mobile ? "c-alert--mobile" : "", o = {
      [ne.SUCCESS]: `c-alert ${r} c-alert__success `,
      [ne.INFO]: `c-alert ${r} c-alert__info`,
      [ne.WARNING]: `c-alert ${r} c-alert__warning`,
      [ne.ERROR]: `c-alert ${r} c-alert__error`
    };
    return (i, a) => (f(), y(od, B({
      modelValue: u(d),
      "onUpdate:modelValue": a[1] || (a[1] = (s) => Hn(d) ? d.value = s : null),
      timeout: n.timeout,
      "content-class": o[n.mode],
      class: "ma-0 pa-0"
    }, { ...i.$attrs }), {
      actions: p(() => [
        D(u(gr), {
          class: "mr-2",
          "data-testid": "close-btn",
          onClick: a[0] || (a[0] = (s) => t("update:modelValue", !1)),
          plain: "",
          size: "x-small",
          "icon-height": "24",
          icon: "ph:x",
          height: "24",
          width: "24"
        })
      ]),
      default: p(() => [
        j("div", mr, [
          j("div", null, [
            S(i.$slots, "icon", {}, () => [
              i.$attrs.icon && typeof i.$attrs.icon == "string" ? (f(), y(u(O), {
                key: 0,
                class: "mr-4",
                color: "inherit",
                "data-testid": "append-icon",
                height: "24px",
                icon: i.$attrs.icon
              }, null, 8, ["icon"])) : I("", !0)
            ], !0)
          ]),
          S(i.$slots, "description", {}, () => [
            D(u(k), {
              variant: n.typography,
              "color-class": "cta"
            }, {
              default: p(() => [
                P(T(n.description), 1)
              ]),
              _: 1
            }, 8, ["variant"])
          ], !0)
        ])
      ]),
      _: 3
    }, 16, ["modelValue", "timeout", "content-class"]));
  }
});
var se = /* @__PURE__ */ ((e) => (e.BIG = "big", e.SMALL = "small", e))(se || {});
const Mr = {
  key: 0,
  class: "radio-checkbox"
}, br = ["checked"], U0 = /* @__PURE__ */ w({
  props: {
    hover: {
      type: Boolean,
      default: !1
    },
    radio: {
      type: Boolean,
      default: !1
    },
    checked: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      default: se.SMALL
    },
    modelValue: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, d = (o) => {
      t("update:modelValue", o);
    }, r = yn({
      hover: !1
    });
    return (o, i) => e.radio ? (f(), C("div", Mr, [
      j("input", {
        type: "radio",
        checked: e.checked,
        class: "hidden"
      }, null, 8, br),
      j("div", {
        class: A([
          "d-flex justiify-center align-center radio",
          { "radio--checked": e.checked }
        ])
      }, [
        D(u(O), {
          height: "20",
          icon: e.checked ? "ph:radio-button-fill" : "ph:circle"
        }, null, 8, ["icon"])
      ], 2)
    ])) : (f(), y(u(ot), B({
      key: 1,
      icon: "",
      class: [
        "c-checkbox",
        { "c-checkbox--hover": e.hover },
        { "c-checkbox--checked": e.checked },
        { "c-checkbox--icon": e.hover || e.checked || u(r).hover }
      ],
      flat: "",
      depressed: "",
      ripple: !1
    }, { ...o.$attrs }, {
      height: e.variant === u(se).SMALL ? 20 : 36,
      width: e.variant === u(se).SMALL ? 20 : 36,
      onMouseenter: i[0] || (i[0] = (a) => u(r).hover = !0),
      onMouseleave: i[1] || (i[1] = (a) => u(r).hover = !1),
      onClick: i[2] || (i[2] = (a) => d(!n.modelValue))
    }), {
      default: p(() => [
        D(u(O), {
          color: "inherit",
          height: e.variant === u(se).SMALL ? 10 : 20,
          icon: "ph:check"
        }, null, 8, ["height"])
      ]),
      _: 1
    }, 16, ["class", "height", "width"]));
  }
});
var U = /* @__PURE__ */ ((e) => (e.WEB = "web", e.FILTER = "filter", e.FILTER_STATIC = "filter_static", e.MINI = "mini", e.MINI_FLOW = "mini_flow", e.BADGE = "badge", e.LANGUAGE = "language", e))(U || {});
const vr = { class: "align-center d-flex language-chip" }, Nr = ["src"], Ir = /* @__PURE__ */ w({
  props: {
    img: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e;
    return (n, d) => (f(), C("div", vr, [
      j("img", {
        src: t.img,
        class: "language-chip__flag"
      }, null, 8, Nr),
      D(k, {
        class: "ml-1",
        "color-class": "copy-primary",
        variant: "body-2-400"
      }, {
        default: p(() => [
          P(T(t.label), 1)
        ]),
        _: 1
      })
    ]));
  }
});
const Cr = /* @__PURE__ */ G(Ir, [["__scopeId", "data-v-016528bd"]]), R0 = /* @__PURE__ */ w({
  props: {
    variant: {
      type: String,
      default: U.MINI
    },
    selected: {
      type: Boolean,
      default: !1
    },
    mobile: {
      type: Boolean,
      default: !1
    },
    img: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, n = Y(!1), d = R(() => t.variant === U.WEB ? "chip--web" : t.variant === U.FILTER ? t.selected ? "chip--filter chip--filter--selected" : "chip--filter" : t.variant === U.FILTER_STATIC ? t.selected ? "chip--filter chip--filter--selected chip--filter--selected--static" : "chip--filter chip--filter--static" : t.variant === U.MINI ? t.mobile ? "chip--mini chip--mini--mobile" : "chip--mini" : t.variant === U.MINI_FLOW ? t.mobile ? "chip--mini-flow chip--mini-flow--mobile" : "chip--mini-flow" : t.variant === U.BADGE ? "chip--badge" : "chip--mini"), r = R(() => t.variant === U.FILTER_STATIC && t.selected ? "ph:check" : t.selected ? n.value ? "ph:x" : "ph:check" : "");
    return (o, i) => e.variant === u(U).LANGUAGE ? (f(), y(Cr, {
      key: 0,
      img: t.img,
      label: t.label
    }, null, 8, ["img", "label"])) : (f(), C("div", {
      key: 1,
      class: A(["d-flex align-center chip", u(d)]),
      onMouseenter: i[0] || (i[0] = (a) => n.value = !0),
      onMouseleave: i[1] || (i[1] = (a) => n.value = !1)
    }, [
      typeof o.$attrs.icon == "string" ? (f(), y(u(O), {
        key: 0,
        height: e.variant === u(U).WEB ? 24 : 14,
        icon: e.variant === u(U).FILTER || e.variant === u(U).FILTER_STATIC ? u(r) : o.$attrs.icon
      }, null, 8, ["height", "icon"])) : I("", !0),
      S(o.$slots, "default", {}, void 0, !0)
    ], 34));
  }
});
var kn = /* @__PURE__ */ ((e) => (e.OUTLINED = "outlined", e))(kn || {});
function B0(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
const Re = (e, t = 1) => e.toString().padStart(t, "0"), F0 = (e) => {
  const t = Math.round(e) ?? 0, n = Re(Math.floor(t / 3600)), d = Re(
    Math.floor((t - Number(n) * 3600) / 60)
  ), r = Re(
    Math.floor(t - Number(n) * 3600) - Number(d) * 60,
    2
  );
  return Number(n) > 0 ? `${n}:${d}:${r}` : `${d}:${r}`;
}, $t = (e, t) => {
  const n = document.querySelector(`.c-${e}-${t} ${e}`);
  n && n.setAttribute("data-testid", `${e}-${t}`);
  const d = document.querySelector(`.c-${e}-${t} .v-label`);
  d && d.setAttribute("data-testid", `label-${t}`);
  const r = document.querySelector(`.c-${e}-${t} .v-field-label--floating`);
  r && r.setAttribute("data-testid", `length-${t}`);
};
var Lt;
const ye = typeof window < "u";
ye && ((Lt = window == null ? void 0 : window.navigator) != null && Lt.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function Or(e) {
  return typeof e == "function" ? e() : u(e);
}
function Dr(e) {
  return e;
}
function wr(e) {
  return Wn() ? (Kn(e), !0) : !1;
}
function Tr(e, t = !0) {
  Zn() ? Te(e) : t ? e() : Jn(e);
}
function jr(e) {
  var t;
  const n = Or(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const Ar = ye ? window : void 0;
ye && window.document;
ye && window.navigator;
ye && window.location;
function Sr(e, t = !1) {
  const n = Y(), d = () => n.value = Boolean(e());
  return d(), Tr(d, t), n;
}
const Je = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, qe = "__vueuse_ssr_handlers__";
Je[qe] = Je[qe] || {};
Je[qe];
var kt = Object.getOwnPropertySymbols, xr = Object.prototype.hasOwnProperty, Er = Object.prototype.propertyIsEnumerable, Lr = (e, t) => {
  var n = {};
  for (var d in e)
    xr.call(e, d) && t.indexOf(d) < 0 && (n[d] = e[d]);
  if (e != null && kt)
    for (var d of kt(e))
      t.indexOf(d) < 0 && Er.call(e, d) && (n[d] = e[d]);
  return n;
};
function kr(e, t, n = {}) {
  const d = n, { window: r = Ar } = d, o = Lr(d, ["window"]);
  let i;
  const a = Sr(() => r && "MutationObserver" in r), s = () => {
    i && (i.disconnect(), i = void 0);
  }, l = gn(() => jr(e), (c) => {
    s(), a.value && r && c && (i = new MutationObserver(t), i.observe(c, o));
  }, { immediate: !0 }), $ = () => {
    s(), l();
  };
  return wr($), {
    isSupported: a,
    stop: $
  };
}
var zt;
(function(e) {
  e.UP = "UP", e.RIGHT = "RIGHT", e.DOWN = "DOWN", e.LEFT = "LEFT", e.NONE = "NONE";
})(zt || (zt = {}));
var zr = Object.defineProperty, Pt = Object.getOwnPropertySymbols, Pr = Object.prototype.hasOwnProperty, _r = Object.prototype.propertyIsEnumerable, _t = (e, t, n) => t in e ? zr(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Ur = (e, t) => {
  for (var n in t || (t = {}))
    Pr.call(t, n) && _t(e, n, t[n]);
  if (Pt)
    for (var n of Pt(t))
      _r.call(t, n) && _t(e, n, t[n]);
  return e;
};
const Rr = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
Ur({
  linear: Dr
}, Rr);
function Ee(e) {
  const t = pe(), n = Y({
    required: (r) => !!r || "Required.",
    max: (r) => r.length <= t.maxLength || `Max ${t.maxLength} characters.`,
    min: (r) => r.length >= t.minLength || `Min ${t.minLength} characters.`
  });
  return { textfieldRules: R(() => {
    const r = [];
    return (t.required === "" || t.required === !0) && r.push(n.value.required), t.maxLength && r.push(n.value.max), t.minLength && r.push(n.value.min), e ? [...r, ...e] : r;
  }) };
}
const Br = {
  key: 1,
  style: { display: "none" }
}, Fr = /* @__PURE__ */ w({
  props: {
    rules: {
      type: Array,
      default: () => []
    },
    autocomplete: {
      type: Boolean,
      default: !1
    },
    noPadding: {
      type: Boolean,
      default: !0
    },
    innerRowClass: {
      type: String,
      default: "ma-1"
    },
    modelValue: {
      type: [String, Array],
      default: null
    },
    clearable: {
      type: Boolean,
      default: !0
    },
    titleVariable: {
      type: String,
      default: ""
    },
    mobile: {
      type: Boolean,
      default: !1
    },
    testId: {
      type: String,
      default: "1"
    },
    iconHeight: {
      type: String,
      default: "16"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, { textfieldRules: d } = Ee(n.rules), r = n.autocomplete ? id : ad, o = Y(!1), i = pe(), a = () => {
      t("update:modelValue", i.multiple === void 0 ? null : []);
    }, s = Y(), l = yn({
      stopCallback: () => {
      }
    });
    Te(() => {
      const { stop: c } = kr(
        s,
        (h) => {
          n.autocomplete && h[0] && !h[0].target.className.includes(
            "v-autocomplete--active-menu"
          ) && document.activeElement.blur();
        },
        {
          attributes: !0,
          attributeFilter: ["class"]
        }
      );
      l.stopCallback = c, $t("input", n.testId);
    });
    const $ = (c) => {
      c && t("update:modelValue", c);
    };
    return qn(() => {
      l.stopCallback();
    }), (c, h) => (f(), C("div", {
      class: A(["w-100", "dropdown", `c-input-${e.testId}`, { "dropdown--focus": o.value }])
    }, [
      (f(), y(ee(u(r)), B({
        density: "comfortable",
        class: [c.$attrs.density === "compact" ? "select-compact" : "select"]
      }, c.$attrs, {
        "bg-color": "aphla-bg",
        color: "alert-blue",
        variant: "outlined",
        rules: u(d),
        label: void 0,
        "model-value": n.modelValue,
        placeholder: c.$attrs.label,
        ref_key: "el",
        ref: s,
        "hide-details": "auto",
        "onUpdate:menu": h[0] || (h[0] = (g) => o.value = g),
        "onUpdate:modelValue": h[1] || (h[1] = (g) => $(g))
      }), re({
        item: p(({ props: g, item: m }) => [
          c.$attrs.multiple === void 0 ? (f(), y(u(Mt), B({ key: 0 }, g, {
            density: c.$attrs.density,
            color: "universal-gray"
          }), {
            title: p(() => [
              D(k, {
                variant: c.$attrs.density === "compact" ? "body-2-400" : "body-1-400"
              }, {
                default: p(() => [
                  P(T((m == null ? void 0 : m.raw[e.titleVariable]) || (m == null ? void 0 : m.raw)), 1)
                ]),
                _: 2
              }, 1032, ["variant"])
            ]),
            _: 2
          }, 1040, ["density"])) : (f(), y(u(Mt), B({ key: 1 }, g, {
            density: c.$attrs.density
          }), {
            title: p(() => [
              D(k, {
                variant: c.$attrs.density === "compact" ? "body-2-400" : "body-1-400"
              }, {
                default: p(() => [
                  P(T(m == null ? void 0 : m.raw), 1)
                ]),
                _: 2
              }, 1032, ["variant"])
            ]),
            prepend: p(() => [
              D(u(O), {
                class: A([
                  "mr-2",
                  "check-icon",
                  { "check-icon--checked": e.modelValue.includes(m.raw) }
                ]),
                height: "20",
                icon: e.modelValue.includes(m.raw) ? "mdi:checkbox-marked" : "mdi:checkbox-blank-outline"
              }, null, 8, ["class", "icon"])
            ]),
            _: 2
          }, 1040, ["density"]))
        ]),
        selection: p(({ index: g }) => [
          n.autocomplete && !o.value ? (f(), y(k, {
            key: 0,
            variant: c.$attrs.density === "compact" ? "body-2-400" : "body-1-400",
            "color-class": c.$attrs.disabled === "" || c.$attrs.disabled === !0 ? "copy-primary-lock" : "copy-primary"
          }, {
            default: p(() => [
              P(T(n.modelValue), 1)
            ]),
            _: 1
          }, 8, ["variant", "color-class"])) : n.autocomplete && o.value ? (f(), C("div", Br)) : c.$attrs.multiple === void 0 ? (f(), y(k, {
            key: 2,
            class: "selected-text",
            "color-class": c.$attrs.disabled === "" || c.$attrs.disabled === !0 ? "copy-primary-lock" : "copy-primary",
            variant: c.$attrs.density === "compact" && !e.mobile ? "body-2-400" : "body-1-400"
          }, {
            default: p(() => [
              P(T(n.modelValue), 1)
            ]),
            _: 1
          }, 8, ["color-class", "variant"])) : g === 0 ? (f(), C(Ce, { key: 3 }, [
            o.value ? (f(), y(k, {
              key: 0,
              variant: c.$attrs.density === "compact" ? "body-2-400" : "body-1-400",
              "color-class": c.$attrs.disabled === "" || c.$attrs.disabled === !0 ? "copy-primary-lock" : "copy-primary"
            }, {
              default: p(() => [
                P(T(u(i).label), 1)
              ]),
              _: 1
            }, 8, ["variant", "color-class"])) : (f(), C(Ce, { key: 1 }, [
              D(k, {
                variant: c.$attrs.density === "compact" ? "body-2-400" : "body-1-400",
                "color-class": c.$attrs.disabled === "" || c.$attrs.disabled === !0 ? "copy-primary-lock" : "copy-primary"
              }, {
                default: p(() => [
                  P(T(u(i).label), 1)
                ]),
                _: 1
              }, 8, ["variant", "color-class"]),
              g === 0 ? (f(), y(k, {
                key: 0,
                variant: c.$attrs.density === "compact" ? "body-2-400" : "body-1-400",
                "color-class": c.$attrs.disabled === "" || c.$attrs.disabled === !0 ? "copy-primary-lock" : "highlight-color"
              }, {
                default: p(() => [
                  P("  " + T("(" + n.modelValue.length + ")"), 1)
                ]),
                _: 1
              }, 8, ["variant", "color-class"])) : I("", !0)
            ], 64))
          ], 64)) : I("", !0)
        ]),
        "append-inner": p(() => [
          D(u(O), {
            class: A(["dropdown-icon", { "dropdown-icon--focus": o.value }]),
            color: "inherit",
            height: 13,
            icon: "ph:caret-down"
          }, null, 8, ["class"])
        ]),
        _: 2
      }, [
        n.clearable ? {
          name: "clear",
          fn: p(() => [
            D(u(O), {
              class: "x-icon",
              color: "inherit",
              height: c.$vuetify.display.mobile ? 14 : 18,
              icon: "ph:x",
              onMousedown: mn(a, ["stop"])
            }, null, 8, ["height", "onMousedown"])
          ])
        } : void 0,
        c.$attrs["prepend-inner-icon"] ? {
          name: "prepend-inner",
          fn: p(() => [
            typeof c.$attrs["prepend-inner-icon"] == "string" ? (f(), y(u(O), {
              key: 0,
              color: "inherit",
              height: `${n.iconHeight}px`,
              icon: c.$attrs["prepend-inner-icon"]
            }, null, 8, ["height", "icon"])) : I("", !0)
          ])
        } : void 0,
        he(Object.keys(c.$slots), (g) => ({
          name: g,
          fn: p((m) => [
            S(c.$slots, g, J(q(m)), void 0, !0)
          ])
        }))
      ]), 1040, ["class", "rules", "model-value", "placeholder"]))
    ], 2));
  }
});
const Qr = /* @__PURE__ */ G(Fr, [["__scopeId", "data-v-3b384bd0"]]), Q0 = /* @__PURE__ */ w({
  props: {
    mode: {
      type: String,
      default: kn.OUTLINED
    },
    autocomplete: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = {
      outlined: Qr
    };
    return (d, r) => (f(), y(ee(n[t.mode]), {
      autocomplete: t.autocomplete
    }, re({
      default: p(() => [
        S(d.$slots, "default")
      ]),
      _: 2
    }, [
      he(Object.keys(d.$slots), (o) => ({
        name: o,
        fn: p((i) => [
          S(d.$slots, o, J(q(i)))
        ])
      }))
    ]), 1032, ["autocomplete"]));
  }
});
const Yr = [
  [
    "Afghanistan (‫افغانستان‬‎)",
    "af",
    "93"
  ],
  [
    "Albania (Shqipëri)",
    "al",
    "355"
  ],
  [
    "Algeria (‫الجزائر‬‎)",
    "dz",
    "213"
  ],
  [
    "American Samoa",
    "as",
    "1",
    5,
    ["684"]
  ],
  [
    "Andorra",
    "ad",
    "376"
  ],
  [
    "Angola",
    "ao",
    "244"
  ],
  [
    "Anguilla",
    "ai",
    "1",
    6,
    ["264"]
  ],
  [
    "Antigua and Barbuda",
    "ag",
    "1",
    7,
    ["268"]
  ],
  [
    "Argentina",
    "ar",
    "54"
  ],
  [
    "Armenia (Հայաստան)",
    "am",
    "374"
  ],
  [
    "Aruba",
    "aw",
    "297"
  ],
  [
    "Ascension Island",
    "ac",
    "247"
  ],
  [
    "Australia",
    "au",
    "61",
    0
  ],
  [
    "Austria (Österreich)",
    "at",
    "43"
  ],
  [
    "Azerbaijan (Azərbaycan)",
    "az",
    "994"
  ],
  [
    "Bahamas",
    "bs",
    "1",
    8,
    ["242"]
  ],
  [
    "Bahrain (‫البحرين‬‎)",
    "bh",
    "973"
  ],
  [
    "Bangladesh (বাংলাদেশ)",
    "bd",
    "880"
  ],
  [
    "Barbados",
    "bb",
    "1",
    9,
    ["246"]
  ],
  [
    "Belarus (Беларусь)",
    "by",
    "375"
  ],
  [
    "Belgium (België)",
    "be",
    "32"
  ],
  [
    "Belize",
    "bz",
    "501"
  ],
  [
    "Benin (Bénin)",
    "bj",
    "229"
  ],
  [
    "Bermuda",
    "bm",
    "1",
    10,
    ["441"]
  ],
  [
    "Bhutan (འབྲུག)",
    "bt",
    "975"
  ],
  [
    "Bolivia",
    "bo",
    "591"
  ],
  [
    "Bosnia and Herzegovina (Босна и Херцеговина)",
    "ba",
    "387"
  ],
  [
    "Botswana",
    "bw",
    "267"
  ],
  [
    "Brazil (Brasil)",
    "br",
    "55"
  ],
  [
    "British Indian Ocean Territory",
    "io",
    "246"
  ],
  [
    "British Virgin Islands",
    "vg",
    "1",
    11,
    ["284"]
  ],
  [
    "Brunei",
    "bn",
    "673"
  ],
  [
    "Bulgaria (България)",
    "bg",
    "359"
  ],
  [
    "Burkina Faso",
    "bf",
    "226"
  ],
  [
    "Burundi (Uburundi)",
    "bi",
    "257"
  ],
  [
    "Cambodia (កម្ពុជា)",
    "kh",
    "855"
  ],
  [
    "Cameroon (Cameroun)",
    "cm",
    "237"
  ],
  [
    "Canada",
    "ca",
    "1",
    1,
    ["204", "226", "236", "249", "250", "263", "289", "306", "343", "354", "365", "367", "368", "382", "387", "403", "416", "418", "428", "431", "437", "438", "450", "584", "468", "474", "506", "514", "519", "548", "579", "581", "584", "587", "604", "613", "639", "647", "672", "683", "705", "709", "742", "753", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]
  ],
  [
    "Cape Verde (Kabu Verdi)",
    "cv",
    "238"
  ],
  [
    "Caribbean Netherlands",
    "bq",
    "599",
    1,
    ["3", "4", "7"]
  ],
  [
    "Cayman Islands",
    "ky",
    "1",
    12,
    ["345"]
  ],
  [
    "Central African Republic (République centrafricaine)",
    "cf",
    "236"
  ],
  [
    "Chad (Tchad)",
    "td",
    "235"
  ],
  [
    "Chile",
    "cl",
    "56"
  ],
  [
    "China (中国)",
    "cn",
    "86"
  ],
  [
    "Christmas Island",
    "cx",
    "61",
    2,
    ["89164"]
  ],
  [
    "Cocos (Keeling) Islands",
    "cc",
    "61",
    1,
    ["89162"]
  ],
  [
    "Colombia",
    "co",
    "57"
  ],
  [
    "Comoros (‫جزر القمر‬‎)",
    "km",
    "269"
  ],
  [
    "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    "cd",
    "243"
  ],
  [
    "Congo (Republic) (Congo-Brazzaville)",
    "cg",
    "242"
  ],
  [
    "Cook Islands",
    "ck",
    "682"
  ],
  [
    "Costa Rica",
    "cr",
    "506"
  ],
  [
    "Côte d’Ivoire",
    "ci",
    "225"
  ],
  [
    "Croatia (Hrvatska)",
    "hr",
    "385"
  ],
  [
    "Cuba",
    "cu",
    "53"
  ],
  [
    "Curaçao",
    "cw",
    "599",
    0
  ],
  [
    "Cyprus (Κύπρος)",
    "cy",
    "357"
  ],
  [
    "Czech Republic (Česká republika)",
    "cz",
    "420"
  ],
  [
    "Denmark (Danmark)",
    "dk",
    "45"
  ],
  [
    "Djibouti",
    "dj",
    "253"
  ],
  [
    "Dominica",
    "dm",
    "1",
    13,
    ["767"]
  ],
  [
    "Dominican Republic (República Dominicana)",
    "do",
    "1",
    2,
    ["809", "829", "849"]
  ],
  [
    "Ecuador",
    "ec",
    "593"
  ],
  [
    "Egypt (‫مصر‬‎)",
    "eg",
    "20"
  ],
  [
    "El Salvador",
    "sv",
    "503"
  ],
  [
    "Equatorial Guinea (Guinea Ecuatorial)",
    "gq",
    "240"
  ],
  [
    "Eritrea",
    "er",
    "291"
  ],
  [
    "Estonia (Eesti)",
    "ee",
    "372"
  ],
  [
    "Eswatini",
    "sz",
    "268"
  ],
  [
    "Ethiopia",
    "et",
    "251"
  ],
  [
    "Falkland Islands (Islas Malvinas)",
    "fk",
    "500"
  ],
  [
    "Faroe Islands (Føroyar)",
    "fo",
    "298"
  ],
  [
    "Fiji",
    "fj",
    "679"
  ],
  [
    "Finland (Suomi)",
    "fi",
    "358",
    0
  ],
  [
    "France",
    "fr",
    "33"
  ],
  [
    "French Guiana (Guyane française)",
    "gf",
    "594"
  ],
  [
    "French Polynesia (Polynésie française)",
    "pf",
    "689"
  ],
  [
    "Gabon",
    "ga",
    "241"
  ],
  [
    "Gambia",
    "gm",
    "220"
  ],
  [
    "Georgia (საქართველო)",
    "ge",
    "995"
  ],
  [
    "Germany (Deutschland)",
    "de",
    "49"
  ],
  [
    "Ghana (Gaana)",
    "gh",
    "233"
  ],
  [
    "Gibraltar",
    "gi",
    "350"
  ],
  [
    "Greece (Ελλάδα)",
    "gr",
    "30"
  ],
  [
    "Greenland (Kalaallit Nunaat)",
    "gl",
    "299"
  ],
  [
    "Grenada",
    "gd",
    "1",
    14,
    ["473"]
  ],
  [
    "Guadeloupe",
    "gp",
    "590",
    0
  ],
  [
    "Guam",
    "gu",
    "1",
    15,
    ["671"]
  ],
  [
    "Guatemala",
    "gt",
    "502"
  ],
  [
    "Guernsey",
    "gg",
    "44",
    1,
    ["1481", "7781", "7839", "7911"]
  ],
  [
    "Guinea (Guinée)",
    "gn",
    "224"
  ],
  [
    "Guinea-Bissau (Guiné Bissau)",
    "gw",
    "245"
  ],
  [
    "Guyana",
    "gy",
    "592"
  ],
  [
    "Haiti",
    "ht",
    "509"
  ],
  [
    "Honduras",
    "hn",
    "504"
  ],
  [
    "Hong Kong (香港)",
    "hk",
    "852"
  ],
  [
    "Hungary (Magyarország)",
    "hu",
    "36"
  ],
  [
    "Iceland (Ísland)",
    "is",
    "354"
  ],
  [
    "India (भारत)",
    "in",
    "91"
  ],
  [
    "Indonesia",
    "id",
    "62"
  ],
  [
    "Iran (‫ایران‬‎)",
    "ir",
    "98"
  ],
  [
    "Iraq (‫العراق‬‎)",
    "iq",
    "964"
  ],
  [
    "Ireland",
    "ie",
    "353"
  ],
  [
    "Isle of Man",
    "im",
    "44",
    2,
    ["1624", "74576", "7524", "7924", "7624"]
  ],
  [
    "Israel (‫ישראל‬‎)",
    "il",
    "972"
  ],
  [
    "Italy (Italia)",
    "it",
    "39",
    0
  ],
  [
    "Jamaica",
    "jm",
    "1",
    4,
    ["876", "658"]
  ],
  [
    "Japan (日本)",
    "jp",
    "81"
  ],
  [
    "Jersey",
    "je",
    "44",
    3,
    ["1534", "7509", "7700", "7797", "7829", "7937"]
  ],
  [
    "Jordan (‫الأردن‬‎)",
    "jo",
    "962"
  ],
  [
    "Kazakhstan (Казахстан)",
    "kz",
    "7",
    1,
    ["33", "7"]
  ],
  [
    "Kenya",
    "ke",
    "254"
  ],
  [
    "Kiribati",
    "ki",
    "686"
  ],
  [
    "Kosovo",
    "xk",
    "383"
  ],
  [
    "Kuwait (‫الكويت‬‎)",
    "kw",
    "965"
  ],
  [
    "Kyrgyzstan (Кыргызстан)",
    "kg",
    "996"
  ],
  [
    "Laos (ລາວ)",
    "la",
    "856"
  ],
  [
    "Latvia (Latvija)",
    "lv",
    "371"
  ],
  [
    "Lebanon (‫لبنان‬‎)",
    "lb",
    "961"
  ],
  [
    "Lesotho",
    "ls",
    "266"
  ],
  [
    "Liberia",
    "lr",
    "231"
  ],
  [
    "Libya (‫ليبيا‬‎)",
    "ly",
    "218"
  ],
  [
    "Liechtenstein",
    "li",
    "423"
  ],
  [
    "Lithuania (Lietuva)",
    "lt",
    "370"
  ],
  [
    "Luxembourg",
    "lu",
    "352"
  ],
  [
    "Macau (澳門)",
    "mo",
    "853"
  ],
  [
    "Madagascar (Madagasikara)",
    "mg",
    "261"
  ],
  [
    "Malawi",
    "mw",
    "265"
  ],
  [
    "Malaysia",
    "my",
    "60"
  ],
  [
    "Maldives",
    "mv",
    "960"
  ],
  [
    "Mali",
    "ml",
    "223"
  ],
  [
    "Malta",
    "mt",
    "356"
  ],
  [
    "Marshall Islands",
    "mh",
    "692"
  ],
  [
    "Martinique",
    "mq",
    "596"
  ],
  [
    "Mauritania (‫موريتانيا‬‎)",
    "mr",
    "222"
  ],
  [
    "Mauritius (Moris)",
    "mu",
    "230"
  ],
  [
    "Mayotte",
    "yt",
    "262",
    1,
    ["269", "639"]
  ],
  [
    "Mexico (México)",
    "mx",
    "52"
  ],
  [
    "Micronesia",
    "fm",
    "691"
  ],
  [
    "Moldova (Republica Moldova)",
    "md",
    "373"
  ],
  [
    "Monaco",
    "mc",
    "377"
  ],
  [
    "Mongolia (Монгол)",
    "mn",
    "976"
  ],
  [
    "Montenegro (Crna Gora)",
    "me",
    "382"
  ],
  [
    "Montserrat",
    "ms",
    "1",
    16,
    ["664"]
  ],
  [
    "Morocco (‫المغرب‬‎)",
    "ma",
    "212",
    0
  ],
  [
    "Mozambique (Moçambique)",
    "mz",
    "258"
  ],
  [
    "Myanmar (Burma) (မြန်မာ)",
    "mm",
    "95"
  ],
  [
    "Namibia (Namibië)",
    "na",
    "264"
  ],
  [
    "Nauru",
    "nr",
    "674"
  ],
  [
    "Nepal (नेपाल)",
    "np",
    "977"
  ],
  [
    "Netherlands (Nederland)",
    "nl",
    "31"
  ],
  [
    "New Caledonia (Nouvelle-Calédonie)",
    "nc",
    "687"
  ],
  [
    "New Zealand",
    "nz",
    "64"
  ],
  [
    "Nicaragua",
    "ni",
    "505"
  ],
  [
    "Niger (Nijar)",
    "ne",
    "227"
  ],
  [
    "Nigeria",
    "ng",
    "234"
  ],
  [
    "Niue",
    "nu",
    "683"
  ],
  [
    "Norfolk Island",
    "nf",
    "672"
  ],
  [
    "North Korea (조선 민주주의 인민 공화국)",
    "kp",
    "850"
  ],
  [
    "North Macedonia (Северна Македонија)",
    "mk",
    "389"
  ],
  [
    "Northern Mariana Islands",
    "mp",
    "1",
    17,
    ["670"]
  ],
  [
    "Norway (Norge)",
    "no",
    "47",
    0
  ],
  [
    "Oman (‫عُمان‬‎)",
    "om",
    "968"
  ],
  [
    "Pakistan (‫پاکستان‬‎)",
    "pk",
    "92"
  ],
  [
    "Palau",
    "pw",
    "680"
  ],
  [
    "Palestine (‫فلسطين‬‎)",
    "ps",
    "970"
  ],
  [
    "Panama (Panamá)",
    "pa",
    "507"
  ],
  [
    "Papua New Guinea",
    "pg",
    "675"
  ],
  [
    "Paraguay",
    "py",
    "595"
  ],
  [
    "Peru (Perú)",
    "pe",
    "51"
  ],
  [
    "Philippines",
    "ph",
    "63"
  ],
  [
    "Poland (Polska)",
    "pl",
    "48"
  ],
  [
    "Portugal",
    "pt",
    "351"
  ],
  [
    "Puerto Rico",
    "pr",
    "1",
    3,
    ["787", "939"]
  ],
  [
    "Qatar (‫قطر‬‎)",
    "qa",
    "974"
  ],
  [
    "Réunion (La Réunion)",
    "re",
    "262",
    0
  ],
  [
    "Romania (România)",
    "ro",
    "40"
  ],
  [
    "Russia (Россия)",
    "ru",
    "7",
    0
  ],
  [
    "Rwanda",
    "rw",
    "250"
  ],
  [
    "Saint Barthélemy",
    "bl",
    "590",
    1
  ],
  [
    "Saint Helena",
    "sh",
    "290"
  ],
  [
    "Saint Kitts and Nevis",
    "kn",
    "1",
    18,
    ["869"]
  ],
  [
    "Saint Lucia",
    "lc",
    "1",
    19,
    ["758"]
  ],
  [
    "Saint Martin (Saint-Martin (partie française))",
    "mf",
    "590",
    2
  ],
  [
    "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    "pm",
    "508"
  ],
  [
    "Saint Vincent and the Grenadines",
    "vc",
    "1",
    20,
    ["784"]
  ],
  [
    "Samoa",
    "ws",
    "685"
  ],
  [
    "San Marino",
    "sm",
    "378"
  ],
  [
    "São Tomé and Príncipe (São Tomé e Príncipe)",
    "st",
    "239"
  ],
  [
    "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
    "sa",
    "966"
  ],
  [
    "Senegal (Sénégal)",
    "sn",
    "221"
  ],
  [
    "Serbia (Србија)",
    "rs",
    "381"
  ],
  [
    "Seychelles",
    "sc",
    "248"
  ],
  [
    "Sierra Leone",
    "sl",
    "232"
  ],
  [
    "Singapore",
    "sg",
    "65"
  ],
  [
    "Sint Maarten",
    "sx",
    "1",
    21,
    ["721"]
  ],
  [
    "Slovakia (Slovensko)",
    "sk",
    "421"
  ],
  [
    "Slovenia (Slovenija)",
    "si",
    "386"
  ],
  [
    "Solomon Islands",
    "sb",
    "677"
  ],
  [
    "Somalia (Soomaaliya)",
    "so",
    "252"
  ],
  [
    "South Africa",
    "za",
    "27"
  ],
  [
    "South Korea (대한민국)",
    "kr",
    "82"
  ],
  [
    "South Sudan (‫جنوب السودان‬‎)",
    "ss",
    "211"
  ],
  [
    "Spain (España)",
    "es",
    "34"
  ],
  [
    "Sri Lanka (ශ්‍රී ලංකාව)",
    "lk",
    "94"
  ],
  [
    "Sudan (‫السودان‬‎)",
    "sd",
    "249"
  ],
  [
    "Suriname",
    "sr",
    "597"
  ],
  [
    "Svalbard and Jan Mayen",
    "sj",
    "47",
    1,
    ["79"]
  ],
  [
    "Sweden (Sverige)",
    "se",
    "46"
  ],
  [
    "Switzerland (Schweiz)",
    "ch",
    "41"
  ],
  [
    "Syria (‫سوريا‬‎)",
    "sy",
    "963"
  ],
  [
    "Taiwan (台灣)",
    "tw",
    "886"
  ],
  [
    "Tajikistan",
    "tj",
    "992"
  ],
  [
    "Tanzania",
    "tz",
    "255"
  ],
  [
    "Thailand (ไทย)",
    "th",
    "66"
  ],
  [
    "Timor-Leste",
    "tl",
    "670"
  ],
  [
    "Togo",
    "tg",
    "228"
  ],
  [
    "Tokelau",
    "tk",
    "690"
  ],
  [
    "Tonga",
    "to",
    "676"
  ],
  [
    "Trinidad and Tobago",
    "tt",
    "1",
    22,
    ["868"]
  ],
  [
    "Tunisia (‫تونس‬‎)",
    "tn",
    "216"
  ],
  [
    "Turkey (Türkiye)",
    "tr",
    "90"
  ],
  [
    "Turkmenistan",
    "tm",
    "993"
  ],
  [
    "Turks and Caicos Islands",
    "tc",
    "1",
    23,
    ["649"]
  ],
  [
    "Tuvalu",
    "tv",
    "688"
  ],
  [
    "U.S. Virgin Islands",
    "vi",
    "1",
    24,
    ["340"]
  ],
  [
    "Uganda",
    "ug",
    "256"
  ],
  [
    "Ukraine (Україна)",
    "ua",
    "380"
  ],
  [
    "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
    "ae",
    "971"
  ],
  [
    "United Kingdom",
    "gb",
    "44",
    0
  ],
  [
    "United States",
    "us",
    "1",
    0
  ],
  [
    "Uruguay",
    "uy",
    "598"
  ],
  [
    "Uzbekistan (Oʻzbekiston)",
    "uz",
    "998"
  ],
  [
    "Vanuatu",
    "vu",
    "678"
  ],
  [
    "Vatican City (Città del Vaticano)",
    "va",
    "39",
    1,
    ["06698"]
  ],
  [
    "Venezuela",
    "ve",
    "58"
  ],
  [
    "Vietnam (Việt Nam)",
    "vn",
    "84"
  ],
  [
    "Wallis and Futuna (Wallis-et-Futuna)",
    "wf",
    "681"
  ],
  [
    "Western Sahara (‫الصحراء الغربية‬‎)",
    "eh",
    "212",
    1,
    ["5288", "5289"]
  ],
  [
    "Yemen (‫اليمن‬‎)",
    "ye",
    "967"
  ],
  [
    "Zambia",
    "zm",
    "260"
  ],
  [
    "Zimbabwe",
    "zw",
    "263"
  ],
  [
    "Åland Islands",
    "ax",
    "358",
    1,
    ["18"]
  ]
], Vr = Yr.map(([e, t, n, d = 0, r = null]) => ({
  name: e,
  iso2: t.toUpperCase(),
  dialCode: n,
  priority: d,
  areaCodes: r
}));
function Gr() {
  return fetch("https://ip2c.org/s").then((e) => e.text()).then((e) => {
    const t = (e || "").toString();
    if (!t || t[0] !== "1")
      throw new Error("unable to fetch the country");
    return t.substr(2, 2);
  });
}
function Hr(e, t) {
  if (e.setSelectionRange)
    e.focus(), e.setSelectionRange(t, t);
  else if (e.createTextRange) {
    const n = e.createTextRange();
    n.collapse(!0), n.moveEnd("character", t), n.moveStart("character", t), n.select();
  }
}
const Wr = [
  {
    name: "allCountries",
    type: Array,
    default: Vr,
    description: "All countries that are used in <code>libphonenumber-js</code>, can be overridden by this prop",
    inDemo: !1
  },
  {
    name: "autoFormat",
    type: Boolean,
    default: !0,
    description: "Auto update the input to the formatted phone number when it's valid",
    inDemo: !0
  },
  {
    name: "customValidate",
    type: [Boolean, RegExp],
    default: !1,
    description: "Custom validation RegExp for input",
    inDemo: !1
  },
  {
    name: "defaultCountry",
    default: "",
    type: [String, Number],
    description: "Default country (by iso2 or dialCode), will override the country fetched from IP address of user",
    inDemo: !1
  },
  {
    name: "disabled",
    default: !1,
    type: Boolean,
    description: "Disable <code>vue-tel-input</code>, including the input & flag dropdown",
    inDemo: !1
  },
  {
    name: "autoDefaultCountry",
    default: !0,
    type: Boolean,
    description: "To fetch default country based on IP address of user",
    inDemo: !1
  },
  {
    name: "dropdownOptions",
    type: Object,
    description: "Options for dropdown, see below",
    inDemo: !1
  },
  {
    name: "dropdownOptions.disabled",
    default: !1,
    type: Boolean,
    description: "Disable dropdown",
    inDemo: !1
  },
  {
    name: "dropdownOptions.showDialCodeInList",
    default: !0,
    type: Boolean,
    description: "Show dial code in the dropdown list",
    inDemo: !0
  },
  {
    name: "dropdownOptions.showDialCodeInSelection",
    default: !1,
    type: Boolean,
    description: "Show dial code in the dropdown selection",
    inDemo: !0
  },
  {
    name: "dropdownOptions.showFlags",
    default: !0,
    type: Boolean,
    description: "Show flags in the dropdown selection and list",
    inDemo: !0
  },
  {
    name: "dropdownOptions.showSearchBox",
    default: !1,
    type: Boolean,
    description: "Show country search box",
    inDemo: !0
  },
  {
    name: "dropdownOptions.tabindex",
    default: 0,
    type: Number,
    description: "Native dropdown <code>tabindex</code> attribute",
    inDemo: !1
  },
  {
    name: "ignoredCountries",
    default: [],
    type: Array,
    description: "List of countries will NOT be shown on the dropdown",
    inDemo: !1
  },
  {
    name: "inputOptions",
    type: Object,
    description: "Options for input, see below",
    inDemo: !1
  },
  {
    name: "inputOptions.autocomplete",
    type: String,
    default: "on",
    description: "Native input <code>autocomplete</code> attribute",
    inDemo: !1
  },
  {
    name: "inputOptions.autofocus",
    type: Boolean,
    default: !1,
    description: "Native input <code>autofocus</code> attribute",
    inDemo: !1
  },
  // {
  //   name: 'inputOptions.dynamicPlaceholder',
  //   default: false,
  //   type: Boolean,
  //   description: 'Placeholder as a sample phone number in the current country',
  //   inDemo: false,
  // },
  {
    name: "inputOptions.aria-describedby",
    default: "",
    type: String,
    description: "Native input <code>aria-describedby</code> attribute",
    inDemo: !1
  },
  {
    name: "inputOptions.id",
    default: "",
    type: String,
    description: "Native input <code>id</code> attribute",
    inDemo: !1
  },
  {
    name: "inputOptions.maxlength",
    default: 25,
    type: Number,
    description: "Native input <code>maxlength</code> attribute",
    inDemo: !1
  },
  {
    name: "inputOptions.name",
    default: "telephone",
    type: String,
    description: "Native input <code>name</code> attribute",
    inDemo: !1
  },
  {
    name: "inputOptions.showDialCode",
    default: !1,
    type: Boolean,
    description: "Show dial code in input",
    inDemo: !1
  },
  {
    name: "inputOptions.placeholder",
    default: "Enter a phone number",
    type: String,
    description: "Placeholder for the input",
    inDemo: !1
  },
  {
    name: "inputOptions.readonly",
    default: !1,
    type: Boolean,
    description: "Native input <code>readonly</code> attribute",
    inDemo: !1
  },
  {
    name: "inputOptions.required",
    default: !1,
    type: Boolean,
    description: "Native input <code>required</code> attribute",
    inDemo: !1
  },
  {
    name: "inputOptions.tabindex",
    default: 0,
    type: Number,
    description: "Native input <code>tabindex</code> attribute",
    inDemo: !1
  },
  {
    name: "inputOptions.type",
    default: "tel",
    type: String,
    description: "Native input <code>type</code> attribute",
    inDemo: !1
  },
  {
    name: "inputOptions.styleClasses",
    default: "",
    type: [String, Array, Object],
    description: "Custom classes for the <code>input</code>",
    inDemo: !1
  },
  {
    name: "invalidMsg",
    default: "",
    type: String,
    description: "",
    inDemo: !1
  },
  {
    name: "mode",
    default: "auto",
    type: String,
    description: "Allowed values: <code>'auto'</code> (Default set by phone),  <code>'international'</code> (Format number with the dial code i.e. + 61), <code>'national'</code> (Format number without dial code i.e. 0321232)",
    inDemo: !0,
    options: ["auto", "national", "international"]
  },
  {
    name: "onlyCountries",
    default: [],
    type: Array,
    description: "List of countries will be shown on the dropdown",
    inDemo: !1
  },
  {
    name: "preferredCountries",
    default: [],
    type: Array,
    description: "Preferred countries list, will be on top of the dropdown",
    inDemo: !1
  },
  {
    name: "styleClasses",
    default: "",
    type: [String, Array, Object],
    description: "Custom classes for the wrapper",
    inDemo: !1
  },
  {
    name: "validCharactersOnly",
    default: !1,
    type: Boolean,
    description: "Only allow valid characters in a phone number (will also verify in <code>mounted</code>, so phone number with invalid characters will be shown as an empty string)",
    inDemo: !1
  }
], Kr = [...Wr].reduce((e, t) => {
  if (t.name.includes(".")) {
    const [n, d] = t.name.split(".");
    e[n] ? Object.assign(e[n], { [d]: t.default }) : Object.assign(e, { [n]: { [d]: t.default } });
  } else
    Object.assign(e, { [t.name]: t.default });
  return e;
}, {}), Ut = {
  options: { ...Kr }
}, Zr = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[047]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[2378]\\d|62|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-8]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:4722|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "810", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function Jr(e, t) {
  var n = Array.prototype.slice.call(t);
  return n.push(Zr), e.apply(this, n);
}
function Xe(e) {
  return Xe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xe(e);
}
function Rt(e, t) {
  for (var n = 0; n < t.length; n++) {
    var d = t[n];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(e, d.key, d);
  }
}
function qr(e, t, n) {
  return t && Rt(e.prototype, t), n && Rt(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Xr(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function eo(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && $e(e, t);
}
function to(e) {
  var t = Pn();
  return function() {
    var n = fe(e), d;
    if (t) {
      var r = fe(this).constructor;
      d = Reflect.construct(n, arguments, r);
    } else
      d = n.apply(this, arguments);
    return no(this, d);
  };
}
function no(e, t) {
  if (t && (Xe(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return zn(e);
}
function zn(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function et(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return et = function(n) {
    if (n === null || !ro(n))
      return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(n))
        return t.get(n);
      t.set(n, d);
    }
    function d() {
      return Ne(n, arguments, fe(this).constructor);
    }
    return d.prototype = Object.create(n.prototype, { constructor: { value: d, enumerable: !1, writable: !0, configurable: !0 } }), $e(d, n);
  }, et(e);
}
function Ne(e, t, n) {
  return Pn() ? Ne = Reflect.construct : Ne = function(d, r, o) {
    var i = [null];
    i.push.apply(i, r);
    var a = Function.bind.apply(d, i), s = new a();
    return o && $e(s, o.prototype), s;
  }, Ne.apply(null, arguments);
}
function Pn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ro(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function $e(e, t) {
  return $e = Object.setPrototypeOf || function(n, d) {
    return n.__proto__ = d, n;
  }, $e(e, t);
}
function fe(e) {
  return fe = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, fe(e);
}
var W = /* @__PURE__ */ function(e) {
  eo(n, e);
  var t = to(n);
  function n(d) {
    var r;
    return Xr(this, n), r = t.call(this, d), Object.setPrototypeOf(zn(r), n.prototype), r.name = r.constructor.name, r;
  }
  return qr(n);
}(/* @__PURE__ */ et(Error)), ft = 2, oo = 17, io = 3, V = "0-9０-９٠-٩۰-۹", ao = "-‐-―−ー－", so = "／/", lo = "．.", uo = "  ­​⁠　", co = "()（）［］\\[\\]", $o = "~⁓∼～", De = "".concat(ao).concat(so).concat(lo).concat(uo).concat(co).concat($o), pt = "+＋";
function Bt(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var n = e[0].split("."), d = t[0].split("."), r = 0; r < 3; r++) {
    var o = Number(n[r]), i = Number(d[r]);
    if (o > i)
      return 1;
    if (i > o)
      return -1;
    if (!isNaN(o) && isNaN(i))
      return 1;
    if (isNaN(o) && !isNaN(i))
      return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var fo = {}.constructor;
function Ie(e) {
  return e != null && e.constructor === fo;
}
function tt(e) {
  return tt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, tt(e);
}
function Le(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ft(e, t) {
  for (var n = 0; n < t.length; n++) {
    var d = t[n];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(e, d.key, d);
  }
}
function ke(e, t, n) {
  return t && Ft(e.prototype, t), n && Ft(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var po = "1.2.0", ho = "1.7.35", Qt = " ext. ", yo = /^\d+$/, z = /* @__PURE__ */ function() {
  function e(t) {
    Le(this, e), bo(t), this.metadata = t, _n.call(this, t);
  }
  return ke(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(t) {
        return t !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(t) {
      return this.metadata.countries[t];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(t) {
      return this.getCountryMetadata(t) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(t) {
      if (this.getCountryCodesForCallingCode(t))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[t])
          return !0;
      } else {
        var n = this.countryCallingCodes()[t];
        if (n && n.length === 1 && n[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(t) {
      return this.nonGeographic() ? !!this.nonGeographic()[t] : !this.getCountryCodesForCallingCode(t);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(t, n) {
      if (t && yo.test(t) && (n = t, t = null), t && t !== "001") {
        if (!this.hasCountry(t))
          throw new Error("Unknown country: ".concat(t));
        this.numberingPlan = new Yt(this.getCountryMetadata(t), this);
      } else if (n) {
        if (!this.hasCallingCode(n))
          throw new Error("Unknown calling code: ".concat(n));
        this.numberingPlan = new Yt(this.getNumberingPlanMetadata(n), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(t) {
      var n = this.countryCallingCodes()[t];
      if (n)
        return n.length === 1 && n[0].length === 3 ? void 0 : n;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(t) {
      var n = this.getCountryCodesForCallingCode(t);
      if (n)
        return n[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(t) {
      var n = this.getCountryCodeForCallingCode(t);
      if (n)
        return this.getCountryMetadata(n);
      if (this.nonGeographic()) {
        var d = this.nonGeographic()[t];
        if (d)
          return d;
      } else {
        var r = this.countryCallingCodes()[t];
        if (r && r.length === 1 && r[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(t) {
      return this.numberingPlan.type(t);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), Yt = /* @__PURE__ */ function() {
  function e(t, n) {
    Le(this, e), this.globalMetadataObject = n, this.metadata = t, _n.call(this, n.metadata);
  }
  return ke(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(t) {
      return t[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var t = this, n = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return n.map(function(d) {
        return new go(d, t);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(t) {
      return t[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(t) {
      if (this.hasTypes() && Vt(this.types(), t))
        return new Mo(Vt(this.types(), t), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? Qt : this.metadata[13] || Qt;
    }
  }]), e;
}(), go = /* @__PURE__ */ function() {
  function e(t, n) {
    Le(this, e), this._format = t, this.metadata = n;
  }
  return ke(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !mo.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), mo = /^\(?\$1\)?$/, Mo = /* @__PURE__ */ function() {
  function e(t, n) {
    Le(this, e), this.type = t, this.metadata = n;
  }
  return ke(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function Vt(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function bo(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!Ie(e) || !Ie(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(Ie(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + vo(e) + ": " + e, "."));
}
var vo = function(e) {
  return tt(e);
};
function ht(e, t) {
  if (t = new z(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function No(e, t) {
  return t.countries.hasOwnProperty(e);
}
function _n(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? Bt(t, po) === -1 ? this.v2 = !0 : Bt(t, ho) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var Io = ";ext=", te = function(e) {
  return "([".concat(V, "]{1,").concat(e, "})");
};
function Un(e) {
  var t = "20", n = "15", d = "9", r = "6", o = "[  \\t,]*", i = "[:\\.．]?[  \\t,-]*", a = "#?", s = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", l = "(?:[xｘ#＃~～]|int|ｉｎｔ)", $ = "[- ]+", c = "[  \\t]*", h = "(?:,{2}|;)", g = Io + te(t), m = o + s + i + te(t) + a, b = o + l + i + te(d) + a, M = $ + te(r) + "#", H = c + h + i + te(n) + a, x = c + "(?:,)+" + i + te(d) + a;
  return g + "|" + m + "|" + b + "|" + M + "|" + H + "|" + x;
}
var Co = "[" + V + "]{" + ft + "}", Oo = "[" + pt + "]{0,1}(?:[" + De + "]*[" + V + "]){3,}[" + De + V + "]*", Do = new RegExp("^[" + pt + "]{0,1}(?:[" + De + "]*[" + V + "]){1,2}$", "i"), wo = Oo + // Phone number extensions
"(?:" + Un() + ")?", To = new RegExp(
  // Either a short two-digit-only phone number
  "^" + Co + "$|^" + wo + "$",
  "i"
);
function jo(e) {
  return e.length >= ft && To.test(e);
}
function Ao(e) {
  return Do.test(e);
}
var Gt = new RegExp("(?:" + Un() + ")$", "i");
function So(e) {
  var t = e.search(Gt);
  if (t < 0)
    return {};
  for (var n = e.slice(0, t), d = e.match(Gt), r = 1; r < d.length; ) {
    if (d[r])
      return {
        number: n,
        ext: d[r]
      };
    r++;
  }
}
var xo = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Eo(e) {
  return xo[e];
}
function Lo(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = ko(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var d = 0;
    return function() {
      return d >= e.length ? { done: !0 } : { done: !1, value: e[d++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ko(e, t) {
  if (e) {
    if (typeof e == "string")
      return Ht(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Ht(e, t);
  }
}
function Ht(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, d = new Array(t); n < t; n++)
    d[n] = e[n];
  return d;
}
function Wt(e) {
  for (var t = "", n = Lo(e.split("")), d; !(d = n()).done; ) {
    var r = d.value;
    t += zo(r, t) || "";
  }
  return t;
}
function zo(e, t) {
  return e === "+" ? t ? void 0 : "+" : Eo(e);
}
function Po(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = _o(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var d = 0;
    return function() {
      return d >= e.length ? { done: !0 } : { done: !1, value: e[d++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _o(e, t) {
  if (e) {
    if (typeof e == "string")
      return Kt(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Kt(e, t);
  }
}
function Kt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, d = new Array(t); n < t; n++)
    d[n] = e[n];
  return d;
}
function Uo(e, t) {
  for (var n = e.slice(), d = Po(t), r; !(r = d()).done; ) {
    var o = r.value;
    e.indexOf(o) < 0 && n.push(o);
  }
  return n.sort(function(i, a) {
    return i - a;
  });
}
function yt(e, t) {
  return Rn(e, void 0, t);
}
function Rn(e, t, n) {
  var d = n.type(t), r = d && d.possibleLengths() || n.possibleLengths();
  if (!r)
    return "IS_POSSIBLE";
  if (t === "FIXED_LINE_OR_MOBILE") {
    if (!n.type("FIXED_LINE"))
      return Rn(e, "MOBILE", n);
    var o = n.type("MOBILE");
    o && (r = Uo(r, o.possibleLengths()));
  } else if (t && !d)
    return "INVALID_LENGTH";
  var i = e.length, a = r[0];
  return a === i ? "IS_POSSIBLE" : a > i ? "TOO_SHORT" : r[r.length - 1] < i ? "TOO_LONG" : r.indexOf(i, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function Ro(e, t, n) {
  if (t === void 0 && (t = {}), n = new z(n), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!n.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      n.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return Bn(e.phone || e.nationalNumber, n);
  if (e.countryCallingCode && n.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function Bn(e, t) {
  switch (yt(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function K(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function Bo(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Fo(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var d = 0;
    return function() {
      return d >= e.length ? { done: !0 } : { done: !1, value: e[d++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Fo(e, t) {
  if (e) {
    if (typeof e == "string")
      return Zt(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Zt(e, t);
  }
}
function Zt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, d = new Array(t); n < t; n++)
    d[n] = e[n];
  return d;
}
var Qo = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function gt(e, t, n) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    n = new z(n), n.selectNumberingPlan(e.country, e.countryCallingCode);
    var d = t.v2 ? e.nationalNumber : e.phone;
    if (K(d, n.nationalNumberPattern())) {
      if (Be(d, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || Be(d, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var r = Bo(Qo), o; !(o = r()).done; ) {
        var i = o.value;
        if (Be(d, i, n))
          return i;
      }
    }
  }
}
function Be(e, t, n) {
  return t = n.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : K(e, t.pattern());
}
function Yo(e, t, n) {
  if (t = t || {}, n = new z(n), n.selectNumberingPlan(e.country, e.countryCallingCode), n.hasTypes())
    return gt(e, t, n.metadata) !== void 0;
  var d = t.v2 ? e.nationalNumber : e.phone;
  return K(d, n.nationalNumberPattern());
}
function Vo(e, t, n) {
  var d = new z(n), r = d.getCountryCodesForCallingCode(e);
  return r ? r.filter(function(o) {
    return Go(t, o, n);
  }) : [];
}
function Go(e, t, n) {
  var d = new z(n);
  return d.selectNumberingPlan(t), d.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
function Ho(e) {
  return e.replace(new RegExp("[".concat(De, "]+"), "g"), " ").trim();
}
var Wo = /(\$\d)/;
function Ko(e, t, n) {
  var d = n.useInternationalFormat, r = n.withNationalPrefix;
  n.carrierCode, n.metadata;
  var o = e.replace(new RegExp(t.pattern()), d ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    r && t.nationalPrefixFormattingRule() ? t.format().replace(Wo, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return d ? Ho(o) : o;
}
var Zo = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function Jo(e, t, n) {
  var d = new z(n);
  if (d.selectNumberingPlan(e, t), d.defaultIDDPrefix())
    return d.defaultIDDPrefix();
  if (Zo.test(d.IDDPrefix()))
    return d.IDDPrefix();
}
function qo(e) {
  var t = e.number, n = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(n ? ";ext=" + n : "");
}
function Xo(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = ei(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var d = 0;
    return function() {
      return d >= e.length ? { done: !0 } : { done: !1, value: e[d++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ei(e, t) {
  if (e) {
    if (typeof e == "string")
      return Jt(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Jt(e, t);
  }
}
function Jt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, d = new Array(t); n < t; n++)
    d[n] = e[n];
  return d;
}
function qt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(e);
    t && (d = d.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, d);
  }
  return n;
}
function Xt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qt(Object(n), !0).forEach(function(d) {
      ti(e, d, n[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qt(Object(n)).forEach(function(d) {
      Object.defineProperty(e, d, Object.getOwnPropertyDescriptor(n, d));
    });
  }
  return e;
}
function ti(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var en = {
  formatExtension: function(e, t, n) {
    return "".concat(e).concat(n.ext()).concat(t);
  }
};
function ni(e, t, n, d) {
  if (n ? n = Xt(Xt({}, en), n) : n = en, d = new z(d), e.country && e.country !== "001") {
    if (!d.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    d.country(e.country);
  } else if (e.countryCallingCode)
    d.selectNumberingPlan(e.countryCallingCode);
  else
    return e.phone || "";
  var r = d.countryCallingCode(), o = n.v2 ? e.nationalNumber : e.phone, i;
  switch (t) {
    case "NATIONAL":
      return o ? (i = we(o, e.carrierCode, "NATIONAL", d, n), Fe(i, e.ext, d, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return o ? (i = we(o, null, "INTERNATIONAL", d, n), i = "+".concat(r, " ").concat(i), Fe(i, e.ext, d, n.formatExtension)) : "+".concat(r);
    case "E.164":
      return "+".concat(r).concat(o);
    case "RFC3966":
      return qo({
        number: "+".concat(r).concat(o),
        ext: e.ext
      });
    case "IDD":
      if (!n.fromCountry)
        return;
      var a = ri(o, e.carrierCode, r, n.fromCountry, d);
      return Fe(a, e.ext, d, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function we(e, t, n, d, r) {
  var o = di(d.formats(), e);
  return o ? Ko(e, o, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(o.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && r && r.nationalPrefix === !1),
    carrierCode: t,
    metadata: d
  }) : e;
}
function di(e, t) {
  for (var n = Xo(e), d; !(d = n()).done; ) {
    var r = d.value;
    if (r.leadingDigitsPatterns().length > 0) {
      var o = r.leadingDigitsPatterns()[r.leadingDigitsPatterns().length - 1];
      if (t.search(o) !== 0)
        continue;
    }
    if (K(t, r.pattern()))
      return r;
  }
}
function Fe(e, t, n, d) {
  return t ? d(e, t, n) : e;
}
function ri(e, t, n, d, r) {
  var o = ht(d, r.metadata);
  if (o === n) {
    var i = we(e, t, "NATIONAL", r);
    return n === "1" ? n + " " + i : i;
  }
  var a = Jo(d, void 0, r.metadata);
  if (a)
    return "".concat(a, " ").concat(n, " ").concat(we(e, null, "INTERNATIONAL", r));
}
function tn(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(e);
    t && (d = d.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, d);
  }
  return n;
}
function nn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tn(Object(n), !0).forEach(function(d) {
      oi(e, d, n[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : tn(Object(n)).forEach(function(d) {
      Object.defineProperty(e, d, Object.getOwnPropertyDescriptor(n, d));
    });
  }
  return e;
}
function oi(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ii(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function dn(e, t) {
  for (var n = 0; n < t.length; n++) {
    var d = t[n];
    d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(e, d.key, d);
  }
}
function ai(e, t, n) {
  return t && dn(e.prototype, t), n && dn(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var si = /* @__PURE__ */ function() {
  function e(t, n, d) {
    if (ii(this, e), !t)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!n)
      throw new TypeError("`nationalNumber` not passed");
    if (!d)
      throw new TypeError("`metadata` not passed");
    var r = ui(t, d), o = r.country, i = r.countryCallingCode;
    this.country = o, this.countryCallingCode = i, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return d;
    };
  }
  return ai(e, [{
    key: "setExt",
    value: function(t) {
      this.ext = t;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : Vo(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return Ro(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return Yo(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var t = new z(this.getMetadata());
      return t.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(t) {
      return this.number === t.number && this.ext === t.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return gt(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(t, n) {
      return ni(this, t, n ? nn(nn({}, n), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(t) {
      return this.format("NATIONAL", t);
    }
  }, {
    key: "formatInternational",
    value: function(t) {
      return this.format("INTERNATIONAL", t);
    }
  }, {
    key: "getURI",
    value: function(t) {
      return this.format("RFC3966", t);
    }
  }]), e;
}(), li = function(e) {
  return /^[A-Z]{2}$/.test(e);
};
function ui(e, t) {
  var n, d, r = new z(t);
  return li(e) ? (n = e, r.selectNumberingPlan(n), d = r.countryCallingCode()) : d = e, {
    country: n,
    countryCallingCode: d
  };
}
var ci = new RegExp("([" + V + "])");
function $i(e, t, n, d) {
  if (t) {
    var r = new z(d);
    r.selectNumberingPlan(t, n);
    var o = new RegExp(r.IDDPrefix());
    if (e.search(o) === 0) {
      e = e.slice(e.match(o)[0].length);
      var i = e.match(ci);
      if (!(i && i[1] != null && i[1].length > 0 && i[1] === "0"))
        return e;
    }
  }
}
function fi(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), d = n.exec(e);
    if (d) {
      var r, o, i = d.length - 1, a = i > 0 && d[i];
      if (t.nationalPrefixTransformRule() && a)
        r = e.replace(n, t.nationalPrefixTransformRule()), i > 1 && (o = d[1]);
      else {
        var s = d[0];
        r = e.slice(s.length), a && (o = d[1]);
      }
      var l;
      if (a) {
        var $ = e.indexOf(d[1]), c = e.slice(0, $);
        c === t.numberingPlan.nationalPrefix() && (l = t.numberingPlan.nationalPrefix());
      } else
        l = d[0];
      return {
        nationalNumber: r,
        nationalPrefix: l,
        carrierCode: o
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function nt(e, t) {
  var n = fi(e, t), d = n.carrierCode, r = n.nationalNumber;
  if (r !== e) {
    if (!pi(e, r, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !hi(r, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: r,
    carrierCode: d
  };
}
function pi(e, t, n) {
  return !(K(e, n.nationalNumberPattern()) && !K(t, n.nationalNumberPattern()));
}
function hi(e, t) {
  switch (yt(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function yi(e, t, n, d) {
  var r = t ? ht(t, d) : n;
  if (e.indexOf(r) === 0) {
    d = new z(d), d.selectNumberingPlan(t, n);
    var o = e.slice(r.length), i = nt(o, d), a = i.nationalNumber, s = nt(e, d), l = s.nationalNumber;
    if (!K(l, d.nationalNumberPattern()) && K(a, d.nationalNumberPattern()) || yt(l, d) === "TOO_LONG")
      return {
        countryCallingCode: r,
        number: o
      };
  }
  return {
    number: e
  };
}
function gi(e, t, n, d) {
  if (!e)
    return {};
  var r;
  if (e[0] !== "+") {
    var o = $i(e, t, n, d);
    if (o && o !== e)
      r = !0, e = "+" + o;
    else {
      if (t || n) {
        var i = yi(e, t, n, d), a = i.countryCallingCode, s = i.number;
        if (a)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: a,
            number: s
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  d = new z(d);
  for (var l = 2; l - 1 <= io && l <= e.length; ) {
    var $ = e.slice(1, l);
    if (d.hasCallingCode($))
      return d.selectNumberingPlan($), {
        countryCallingCodeSource: r ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: $,
        number: e.slice(l)
      };
    l++;
  }
  return {};
}
function mi(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Mi(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var d = 0;
    return function() {
      return d >= e.length ? { done: !0 } : { done: !1, value: e[d++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Mi(e, t) {
  if (e) {
    if (typeof e == "string")
      return rn(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return rn(e, t);
  }
}
function rn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, d = new Array(t); n < t; n++)
    d[n] = e[n];
  return d;
}
function bi(e, t) {
  var n = t.countries, d = t.defaultCountry, r = t.metadata;
  r = new z(r);
  for (var o = [], i = mi(n), a; !(a = i()).done; ) {
    var s = a.value;
    if (r.country(s), r.leadingDigits()) {
      if (e && e.search(r.leadingDigits()) === 0)
        return s;
    } else if (gt({
      phone: e,
      country: s
    }, void 0, r.metadata))
      if (d) {
        if (s === d)
          return s;
        o.push(s);
      } else
        return s;
  }
  if (o.length > 0)
    return o[0];
}
function vi(e, t) {
  var n = t.nationalNumber, d = t.defaultCountry, r = t.metadata, o = r.getCountryCodesForCallingCode(e);
  if (o)
    return o.length === 1 ? o[0] : bi(n, {
      countries: o,
      defaultCountry: d,
      metadata: r.metadata
    });
}
var Fn = "+", Ni = "[\\-\\.\\(\\)]?", on = "([" + V + "]|" + Ni + ")", Ii = "^\\" + Fn + on + "*[" + V + "]" + on + "*$", Ci = new RegExp(Ii, "g"), dt = V, Oi = "[" + dt + "]+((\\-)*[" + dt + "])*", Di = "a-zA-Z", wi = "[" + Di + "]+((\\-)*[" + dt + "])*", Ti = "^(" + Oi + "\\.)*" + wi + "\\.?$", ji = new RegExp(Ti, "g"), an = "tel:", rt = ";phone-context=", Ai = ";isub=";
function Si(e) {
  var t = e.indexOf(rt);
  if (t < 0)
    return null;
  var n = t + rt.length;
  if (n >= e.length)
    return "";
  var d = e.indexOf(";", n);
  return d >= 0 ? e.substring(n, d) : e.substring(n);
}
function xi(e) {
  return e === null ? !0 : e.length === 0 ? !1 : Ci.test(e) || ji.test(e);
}
function Ei(e, t) {
  var n = t.extractFormattedPhoneNumber, d = Si(e);
  if (!xi(d))
    throw new W("NOT_A_NUMBER");
  var r;
  if (d === null)
    r = n(e) || "";
  else {
    r = "", d.charAt(0) === Fn && (r += d);
    var o = e.indexOf(an), i;
    o >= 0 ? i = o + an.length : i = 0;
    var a = e.indexOf(rt);
    r += e.substring(i, a);
  }
  var s = r.indexOf(Ai);
  if (s > 0 && (r = r.substring(0, s)), r !== "")
    return r;
}
var Li = 250, ki = new RegExp("[" + pt + V + "]"), zi = new RegExp("[^" + V + "#]+$");
function Pi(e, t, n) {
  if (t = t || {}, n = new z(n), t.defaultCountry && !n.hasCountry(t.defaultCountry))
    throw t.v2 ? new W("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var d = Ui(e, t.v2, t.extract), r = d.number, o = d.ext, i = d.error;
  if (!r) {
    if (t.v2)
      throw i === "TOO_SHORT" ? new W("TOO_SHORT") : new W("NOT_A_NUMBER");
    return {};
  }
  var a = Bi(r, t.defaultCountry, t.defaultCallingCode, n), s = a.country, l = a.nationalNumber, $ = a.countryCallingCode, c = a.countryCallingCodeSource, h = a.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new W("INVALID_COUNTRY");
    return {};
  }
  if (!l || l.length < ft) {
    if (t.v2)
      throw new W("TOO_SHORT");
    return {};
  }
  if (l.length > oo) {
    if (t.v2)
      throw new W("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var g = new si($, l, n.metadata);
    return s && (g.country = s), h && (g.carrierCode = h), o && (g.ext = o), g.__countryCallingCodeSource = c, g;
  }
  var m = (t.extended ? n.hasSelectedNumberingPlan() : s) ? K(l, n.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: s,
    countryCallingCode: $,
    carrierCode: h,
    valid: m,
    possible: m ? !0 : !!(t.extended === !0 && n.possibleLengths() && Bn(l, n)),
    phone: l,
    ext: o
  } : m ? Ri(s, l, o) : {};
}
function _i(e, t, n) {
  if (e) {
    if (e.length > Li) {
      if (n)
        throw new W("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var d = e.search(ki);
    if (!(d < 0))
      return e.slice(d).replace(zi, "");
  }
}
function Ui(e, t, n) {
  var d = Ei(e, {
    extractFormattedPhoneNumber: function(o) {
      return _i(o, n, t);
    }
  });
  if (!d)
    return {};
  if (!jo(d))
    return Ao(d) ? {
      error: "TOO_SHORT"
    } : {};
  var r = So(d);
  return r.ext ? r : {
    number: d
  };
}
function Ri(e, t, n) {
  var d = {
    country: e,
    phone: t
  };
  return n && (d.ext = n), d;
}
function Bi(e, t, n, d) {
  var r = gi(Wt(e), t, n, d.metadata), o = r.countryCallingCodeSource, i = r.countryCallingCode, a = r.number, s;
  if (i)
    d.selectNumberingPlan(i);
  else if (a && (t || n))
    d.selectNumberingPlan(t, n), t && (s = t), i = n || ht(t, d.metadata);
  else
    return {};
  if (!a)
    return {
      countryCallingCodeSource: o,
      countryCallingCode: i
    };
  var l = nt(Wt(a), d), $ = l.nationalNumber, c = l.carrierCode, h = vi(i, {
    nationalNumber: $,
    defaultCountry: t,
    metadata: d
  });
  return h && (s = h, h === "001" || d.country(s)), {
    country: s,
    countryCallingCode: i,
    countryCallingCodeSource: o,
    nationalNumber: $,
    carrierCode: c
  };
}
function sn(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(e);
    t && (d = d.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, d);
  }
  return n;
}
function ln(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? sn(Object(n), !0).forEach(function(d) {
      Fi(e, d, n[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : sn(Object(n)).forEach(function(d) {
      Object.defineProperty(e, d, Object.getOwnPropertyDescriptor(n, d));
    });
  }
  return e;
}
function Fi(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Qi(e, t, n) {
  return Pi(e, ln(ln({}, t), {}, {
    v2: !0
  }), n);
}
function un(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(e);
    t && (d = d.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, d);
  }
  return n;
}
function Yi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? un(Object(n), !0).forEach(function(d) {
      Vi(e, d, n[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : un(Object(n)).forEach(function(d) {
      Object.defineProperty(e, d, Object.getOwnPropertyDescriptor(n, d));
    });
  }
  return e;
}
function Vi(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Gi(e, t) {
  return Zi(e) || Ki(e, t) || Wi(e, t) || Hi();
}
function Hi() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Wi(e, t) {
  if (e) {
    if (typeof e == "string")
      return cn(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return cn(e, t);
  }
}
function cn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, d = new Array(t); n < t; n++)
    d[n] = e[n];
  return d;
}
function Ki(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var d = [], r = !0, o = !1, i, a;
    try {
      for (n = n.call(e); !(r = (i = n.next()).done) && (d.push(i.value), !(t && d.length === t)); r = !0)
        ;
    } catch (s) {
      o = !0, a = s;
    } finally {
      try {
        !r && n.return != null && n.return();
      } finally {
        if (o)
          throw a;
      }
    }
    return d;
  }
}
function Zi(e) {
  if (Array.isArray(e))
    return e;
}
function Ji(e) {
  var t = Array.prototype.slice.call(e), n = Gi(t, 4), d = n[0], r = n[1], o = n[2], i = n[3], a, s, l;
  if (typeof d == "string")
    a = d;
  else
    throw new TypeError("A text for parsing must be a string.");
  if (!r || typeof r == "string")
    i ? (s = o, l = i) : (s = void 0, l = o), r && (s = Yi({
      defaultCountry: r
    }, s));
  else if (Ie(r))
    o ? (s = r, l = o) : l = r;
  else
    throw new Error("Invalid second argument: ".concat(r));
  return {
    text: a,
    options: s,
    metadata: l
  };
}
function $n(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(e);
    t && (d = d.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, d);
  }
  return n;
}
function fn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $n(Object(n), !0).forEach(function(d) {
      qi(e, d, n[d]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $n(Object(n)).forEach(function(d) {
      Object.defineProperty(e, d, Object.getOwnPropertyDescriptor(n, d));
    });
  }
  return e;
}
function qi(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Xi(e, t, n) {
  t && t.defaultCountry && !No(t.defaultCountry, n) && (t = fn(fn({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return Qi(e, t, n);
  } catch (d) {
    if (!(d instanceof W))
      throw d;
  }
}
function e0() {
  var e = Ji(arguments), t = e.text, n = e.options, d = e.metadata;
  return Xi(t, n, d);
}
function Qe() {
  return Jr(e0, arguments);
}
const t0 = {
  beforeMount(e, t, n) {
    if (typeof t.value != "function") {
      const d = n.context.name;
      let r = `[Vue-click-outside:] provided expression ${t.expression} is not a function, but has to be`;
      d && (r += `Found in component ${d}`), console.warn(r);
    }
    e.clickOutsideEvent = function(d) {
      const r = d.composedPath ? d.composedPath() : d.path;
      e === d.target || e.contains(d.target) || r.includes(e) || t.value(d, e);
    }, document.body.addEventListener("click", e.clickOutsideEvent);
  },
  unmounted(e) {
    document.body.removeEventListener("click", e.clickOutsideEvent);
  }
}, n0 = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [d, r] of t)
    n[d] = r;
  return n;
};
function E(e) {
  const t = Ut.options[e];
  return typeof t > "u" ? Ut.options[e] : t;
}
const d0 = {
  name: "VueTelInput",
  directives: {
    clickOutside: t0
  },
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    allCountries: {
      type: Array,
      default: () => E("allCountries")
    },
    autoFormat: {
      type: Boolean,
      default: () => E("autoFormat")
    },
    customValidate: {
      type: [Boolean, RegExp],
      default: () => E("customValidate")
    },
    defaultCountry: {
      // Default country code, ie: 'AU'
      // Will override the current country of user
      type: [String, Number],
      default: () => E("defaultCountry")
    },
    disabled: {
      type: Boolean,
      default: () => E("disabled")
    },
    autoDefaultCountry: {
      type: Boolean,
      default: () => E("autoDefaultCountry")
    },
    dropdownOptions: {
      type: Object,
      default: () => E("dropdownOptions")
    },
    ignoredCountries: {
      type: Array,
      default: () => E("ignoredCountries")
    },
    inputOptions: {
      type: Object,
      default: () => E("inputOptions")
    },
    invalidMsg: {
      type: String,
      default: () => E("invalidMsg")
    },
    mode: {
      type: String,
      default: () => E("mode")
    },
    onlyCountries: {
      type: Array,
      default: () => E("onlyCountries")
    },
    preferredCountries: {
      type: Array,
      default: () => E("preferredCountries")
    },
    validCharactersOnly: {
      type: Boolean,
      default: () => E("validCharactersOnly")
    },
    styleClasses: {
      type: [String, Array, Object],
      default: () => E("styleClasses")
    }
  },
  data() {
    return {
      phone: "",
      activeCountryCode: "",
      open: !1,
      finishMounted: !1,
      selectedIndex: null,
      typeToFindInput: "",
      typeToFindTimer: null,
      dropdownOpenDirection: "below",
      parsedPlaceholder: this.inputOptions.placeholder,
      searchQuery: ""
    };
  },
  computed: {
    activeCountry() {
      return this.findCountry(this.activeCountryCode);
    },
    parsedMode() {
      return this.mode === "auto" ? !this.phone || this.phone[0] !== "+" ? "national" : "international" : ["international", "national"].includes(this.mode) ? this.mode : (console.error('Invalid value of prop "mode"'), "international");
    },
    filteredCountries() {
      return this.onlyCountries.length ? this.allCountries.filter(({ iso2: e }) => this.onlyCountries.some((t) => t.toUpperCase() === e)) : this.ignoredCountries.length ? this.allCountries.filter(
        ({ iso2: e }) => !this.ignoredCountries.includes(e.toUpperCase()) && !this.ignoredCountries.includes(e.toLowerCase())
      ) : this.allCountries;
    },
    sortedCountries() {
      const e = [...this.getCountries(this.preferredCountries).map((n) => ({ ...n, preferred: !0 })), ...this.filteredCountries];
      if (!this.dropdownOptions.showSearchBox)
        return e;
      const t = this.searchQuery.replace(/[~`!@#$%^&*()+={}\[\];:\'\"<>.,\/\\\?-_]/g, "");
      return e.filter(
        (n) => new RegExp(t, "i").test(n.name) || new RegExp(t, "i").test(n.iso2) || new RegExp(t, "i").test(n.dialCode)
      );
    },
    phoneObject() {
      var e, t, n;
      let d;
      ((e = this.phone) == null ? void 0 : e[0]) === "+" ? d = Qe(this.phone) || {} : d = Qe(this.phone, this.activeCountryCode) || {};
      const {
        metadata: r,
        ...o
      } = d;
      let i = (t = d.isValid) == null ? void 0 : t.call(d), a = this.phone;
      return i && (a = (n = d.format) == null ? void 0 : n.call(d, this.parsedMode.toUpperCase())), d.country && (this.ignoredCountries.length || this.onlyCountries.length) && (this.findCountry(d.country) || (i = !1, Object.assign(d, { country: null }))), Object.assign(o, {
        countryCode: d.country,
        valid: i,
        country: this.activeCountry,
        formatted: a
      }), o;
    }
  },
  watch: {
    activeCountry(e, t) {
      if (!e && t != null && t.iso2) {
        this.activeCountryCode = t.iso2;
        return;
      }
      e != null && e.iso2 && this.$emit("country-changed", e);
    },
    "phoneObject.countryCode": function(e) {
      this.activeCountryCode = e || "";
    },
    "phoneObject.valid": function() {
      this.$emit("validate", this.phoneObject);
    },
    "phoneObject.formatted": function(e) {
      !this.autoFormat || this.customValidate || (this.emitInput(e), this.$nextTick(() => {
        e && !this.modelValue && (this.phone = e);
      }));
    },
    // finishMounted() {
    //   this.resetPlaceholder();
    // },
    "inputOptions.placeholder": function() {
      this.resetPlaceholder();
    },
    modelValue(e, t) {
      this.testCharacters() ? this.phone = e : this.$nextTick(() => {
        this.phone = t, this.onInput();
      });
    },
    open(e) {
      e ? (this.setDropdownPosition(), this.$emit("open")) : this.$emit("close");
    }
  },
  mounted() {
    this.modelValue && (this.phone = this.modelValue.trim()), this.cleanInvalidCharacters(), this.initializeCountry().then(() => {
      var e;
      !this.phone && (e = this.inputOptions) != null && e.showDialCode && this.activeCountryCode && (this.phone = `+${this.activeCountryCode}`), this.$emit("validate", this.phoneObject);
    }).catch(console.error).then(() => {
      this.finishMounted = !0;
    });
  },
  methods: {
    resetPlaceholder() {
      this.parsedPlaceholder = this.inputOptions.placeholder;
    },
    initializeCountry() {
      return new Promise((e) => {
        var t;
        if (((t = this.phone) == null ? void 0 : t[0]) === "+") {
          e();
          return;
        }
        if (this.defaultCountry) {
          if (typeof this.defaultCountry == "string") {
            this.choose(this.defaultCountry), e();
            return;
          }
          if (typeof this.defaultCountry == "number") {
            const d = this.findCountryByDialCode(this.defaultCountry);
            if (d) {
              this.choose(d.iso2), e();
              return;
            }
          }
        }
        const n = this.preferredCountries[0] || this.filteredCountries[0];
        this.autoDefaultCountry ? Gr().then((d) => {
          this.choose(d || this.activeCountryCode);
        }).catch((d) => {
          console.warn(d), this.choose(n);
        }).then(() => {
          e();
        }) : (this.choose(n), e());
      });
    },
    /**
     * Get the list of countries from the list of iso2 code
     */
    getCountries(e = []) {
      return e.map((t) => this.findCountry(t)).filter(Boolean);
    },
    findCountry(e = "") {
      return this.filteredCountries.find((t) => t.iso2 === e.toUpperCase());
    },
    findCountryByDialCode(e) {
      return this.filteredCountries.find((t) => Number(t.dialCode) === e);
    },
    getItemClass(e, t) {
      const n = this.selectedIndex === e, d = e === this.preferredCountries.length - 1, r = this.preferredCountries.some((o) => o.toUpperCase() === t);
      return {
        highlighted: n,
        "last-preferred": d,
        preferred: r
      };
    },
    choose(e) {
      var t, n;
      let d = e;
      if (typeof d == "string" && (d = this.findCountry(d)), !!d) {
        if (((t = this.phone) == null ? void 0 : t[0]) === "+" && d.iso2 && this.phoneObject.nationalNumber) {
          this.activeCountryCode = d.iso2, this.phone = Qe(
            this.phoneObject.nationalNumber,
            d.iso2
          ).formatInternational();
          return;
        }
        if ((n = this.inputOptions) != null && n.showDialCode && d) {
          this.phone = `+${d.dialCode}`, this.activeCountryCode = d.iso2 || "";
          return;
        }
        this.activeCountryCode = d.iso2 || "", this.emitInput(this.phone);
      }
    },
    cleanInvalidCharacters() {
      const e = this.phone;
      if (this.validCharactersOnly) {
        const t = this.phone.match(/[()\-+0-9\s]*/g);
        this.phone = t.join("");
      }
      if (this.customValidate && this.customValidate instanceof RegExp) {
        const t = this.phone.match(this.customValidate);
        this.phone = t.join("");
      }
      e !== this.phone && this.emitInput(this.phone);
    },
    testCharacters() {
      return this.validCharactersOnly && !/^[()\-+0-9\s]*$/.test(this.phone) ? !1 : this.customValidate ? this.testCustomValidate() : !0;
    },
    testCustomValidate() {
      return this.customValidate instanceof RegExp ? this.customValidate.test(this.phone) : !1;
    },
    onInput() {
      this.$refs.input.setCustomValidity(this.phoneObject.valid ? "" : this.invalidMsg), this.emitInput(this.phone);
    },
    emitInput(e) {
      this.$emit("update:modelValue", e), this.$emit("on-input", e, this.phoneObject, this.$refs.input);
    },
    onBlur() {
      this.$emit("blur");
    },
    onFocus() {
      Hr(this.$refs.input, this.phone.length), this.$emit("focus");
    },
    onEnter() {
      this.$emit("enter");
    },
    onSpace() {
      this.$emit("space");
    },
    focus() {
      this.$refs.input.focus();
    },
    toggleDropdown() {
      this.disabled || this.dropdownOptions.disabled || (this.searchQuery = "", this.open = !this.open);
    },
    clickedOutside() {
      this.open = !1;
    },
    keyboardNav(e) {
      if (e.keyCode === 40) {
        e.preventDefault(), this.open = !0, this.selectedIndex === null ? this.selectedIndex = 0 : this.selectedIndex = Math.min(this.sortedCountries.length - 1, this.selectedIndex + 1);
        const t = this.$refs.list.children[this.selectedIndex];
        t.focus(), t.offsetTop + t.clientHeight > this.$refs.list.scrollTop + this.$refs.list.clientHeight && (this.$refs.list.scrollTop = t.offsetTop - this.$refs.list.clientHeight + t.clientHeight);
      } else if (e.keyCode === 38) {
        e.preventDefault(), this.open = !0, this.selectedIndex === null ? this.selectedIndex = this.sortedCountries.length - 1 : this.selectedIndex = Math.max(0, this.selectedIndex - 1);
        const t = this.$refs.list.children[this.selectedIndex];
        t.focus(), t.offsetTop < this.$refs.list.scrollTop && (this.$refs.list.scrollTop = t.offsetTop);
      } else if (e.keyCode === 13)
        this.selectedIndex !== null && this.choose(this.sortedCountries[this.selectedIndex]), this.open = !this.open;
      else {
        this.typeToFindInput += e.key, clearTimeout(this.typeToFindTimer), this.typeToFindTimer = setTimeout(() => {
          this.typeToFindInput = "";
        }, 700);
        const t = this.sortedCountries.slice(this.preferredCountries.length).findIndex((n) => n.name.toLowerCase().startsWith(this.typeToFindInput));
        if (t >= 0) {
          this.selectedIndex = this.preferredCountries.length + t;
          const n = this.$refs.list.children[this.selectedIndex], d = n.offsetTop < this.$refs.list.scrollTop, r = n.offsetTop + n.clientHeight > this.$refs.list.scrollTop + this.$refs.list.clientHeight;
          (d || r) && (this.$refs.list.scrollTop = n.offsetTop - this.$refs.list.clientHeight / 2);
        }
      }
    },
    reset() {
      this.selectedIndex = this.sortedCountries.map((e) => e.iso2).indexOf(this.activeCountryCode), this.open = !1;
    },
    setDropdownPosition() {
      window.innerHeight - this.$el.getBoundingClientRect().bottom > 200 ? this.dropdownOpenDirection = "below" : this.dropdownOpenDirection = "above";
    }
  }
}, r0 = ["aria-expanded", "tabindex"], o0 = { class: "vti__selection" }, i0 = {
  key: 1,
  class: "vti__country-code"
}, a0 = { class: "vti__dropdown-arrow" }, s0 = ["placeholder"], l0 = ["onClick", "onMousemove", "aria-selected"], u0 = { key: 1 }, c0 = ["type", "autocomplete", "autofocus", "disabled", "id", "maxlength", "name", "placeholder", "readonly", "required", "tabindex", "value", "aria-describedby"];
function $0(e, t, n, d, r, o) {
  const i = Xn("click-outside");
  return f(), C("div", {
    class: A(["vue-tel-input", n.styleClasses, { disabled: n.disabled }])
  }, [
    Pe((f(), C("div", {
      "aria-label": "Country Code Selector",
      "aria-haspopup": "listbox",
      "aria-expanded": r.open,
      role: "button",
      class: A(["vti__dropdown", { open: r.open, disabled: n.dropdownOptions.disabled }]),
      tabindex: n.dropdownOptions.tabindex,
      onKeydown: [
        t[2] || (t[2] = (...a) => o.keyboardNav && o.keyboardNav(...a)),
        t[4] || (t[4] = ie((...a) => o.toggleDropdown && o.toggleDropdown(...a), ["space"])),
        t[5] || (t[5] = ie((...a) => o.reset && o.reset(...a), ["esc"])),
        t[6] || (t[6] = ie((...a) => o.reset && o.reset(...a), ["tab"]))
      ],
      onClick: t[3] || (t[3] = (...a) => o.toggleDropdown && o.toggleDropdown(...a))
    }, [
      j("span", o0, [
        n.dropdownOptions.showFlags ? (f(), C("span", {
          key: 0,
          class: A(["vti__flag", r.activeCountryCode.toLowerCase()])
        }, null, 2)) : I("", !0),
        n.dropdownOptions.showDialCodeInSelection ? (f(), C("span", i0, " +" + T(o.activeCountry && o.activeCountry.dialCode), 1)) : I("", !0),
        S(e.$slots, "arrow-icon", { open: r.open }, () => [
          j("span", a0, T(r.open ? "▲" : "▼"), 1)
        ])
      ]),
      r.open ? (f(), C("ul", {
        key: 0,
        ref: "list",
        class: A(["vti__dropdown-list", r.dropdownOpenDirection]),
        role: "listbox"
      }, [
        n.dropdownOptions.showSearchBox ? Pe((f(), C("input", {
          key: 0,
          class: "vti__input vti__search_box",
          "aria-label": "Search by country name or country code",
          placeholder: o.sortedCountries.length ? o.sortedCountries[0].name : "",
          type: "text",
          "onUpdate:modelValue": t[0] || (t[0] = (a) => r.searchQuery = a),
          onClick: t[1] || (t[1] = mn(() => {
          }, ["stop"]))
        }, null, 8, s0)), [
          [ed, r.searchQuery]
        ]) : I("", !0),
        (f(!0), C(Ce, null, he(o.sortedCountries, (a, s) => (f(), C("li", {
          role: "option",
          class: A(["vti__dropdown-item", o.getItemClass(s, a.iso2)]),
          key: a.iso2 + (a.preferred ? "-preferred" : ""),
          tabindex: "-1",
          onClick: (l) => o.choose(a),
          onMousemove: (l) => r.selectedIndex = s,
          "aria-selected": r.activeCountryCode === a.iso2 && !a.preferred
        }, [
          n.dropdownOptions.showFlags ? (f(), C("span", {
            key: 0,
            class: A(["vti__flag", a.iso2.toLowerCase()])
          }, null, 2)) : I("", !0),
          j("strong", null, T(a.name), 1),
          n.dropdownOptions.showDialCodeInList ? (f(), C("span", u0, " +" + T(a.dialCode), 1)) : I("", !0)
        ], 42, l0))), 128))
      ], 2)) : I("", !0)
    ], 42, r0)), [
      [i, o.clickedOutside]
    ]),
    Pe(j("input", {
      "onUpdate:modelValue": t[7] || (t[7] = (a) => r.phone = a),
      ref: "input",
      type: n.inputOptions.type,
      autocomplete: n.inputOptions.autocomplete,
      autofocus: n.inputOptions.autofocus,
      class: A(["vti__input", n.inputOptions.styleClasses]),
      disabled: n.disabled,
      id: n.inputOptions.id,
      maxlength: n.inputOptions.maxlength,
      name: n.inputOptions.name,
      placeholder: r.parsedPlaceholder,
      readonly: n.inputOptions.readonly,
      required: n.inputOptions.required,
      tabindex: n.inputOptions.tabindex,
      value: n.modelValue,
      "aria-describedby": n.inputOptions["aria-describedby"],
      onBlur: t[8] || (t[8] = (...a) => o.onBlur && o.onBlur(...a)),
      onFocus: t[9] || (t[9] = (...a) => o.onFocus && o.onFocus(...a)),
      onInput: t[10] || (t[10] = (...a) => o.onInput && o.onInput(...a)),
      onKeyup: [
        t[11] || (t[11] = ie((...a) => o.onEnter && o.onEnter(...a), ["enter"])),
        t[12] || (t[12] = ie((...a) => o.onSpace && o.onSpace(...a), ["space"]))
      ]
    }, null, 42, c0), [
      [td, r.phone]
    ]),
    S(e.$slots, "icon-right")
  ], 2);
}
const Y0 = /* @__PURE__ */ n0(d0, [["render", $0]]);
var Qn = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.PLAIN = "plain", e.SEARCH = "search", e.OUTLINED = "outlined", e))(Qn || {}), de = /* @__PURE__ */ ((e) => (e.COMFORTABLE = "comfortable", e.COMPACT = "compact", e))(de || {});
const f0 = /* @__PURE__ */ w({
  props: {
    rules: {
      type: Array,
      default: () => []
    },
    iconHeight: {
      type: String,
      default: "16"
    },
    noPadding: {
      type: Boolean,
      default: !0
    },
    noMargin: {
      type: Boolean,
      default: !1
    },
    mobile: {
      type: Boolean,
      default: !1
    },
    testId: {
      type: String,
      default: "1"
    }
  },
  emits: [
    "click:append",
    "click:appendInner",
    "click:prepend",
    "click:prependInner"
  ],
  setup(e, { emit: t }) {
    const n = e, d = Y(0), r = Y(!1), o = pe(), { textfieldRules: i } = Ee(n.rules), a = R(() => {
      if (!d.value || r.value)
        return o.label;
    });
    return Te(() => {
      $t("input", n.testId);
    }), (s, l) => (f(), y(u(Mn), {
      class: A([
        "c-input",
        `c-input-${e.testId}`,
        {
          "c-input--small-font": s.$attrs.density === u(de).COMPACT || e.mobile
        }
      ])
    }, {
      default: p(() => [
        D(u(je), B(s.$attrs, {
          "hide-details": "auto",
          rules: u(i),
          variant: "outlined",
          "bg-color": "aphla-bg",
          color: "button-primary",
          "onUpdate:focused": l[4] || (l[4] = ($) => r.value = $),
          "onUpdate:modelValue": l[5] || (l[5] = ($) => d.value = $.length),
          label: u(a)
        }), re({ _: 2 }, [
          s.$attrs["append-icon"] ? {
            name: "append",
            fn: p(() => [
              typeof s.$attrs["append-icon"] == "string" ? (f(), y(u(O), {
                key: 0,
                class: "v-icon--clickable",
                onClick: l[0] || (l[0] = ($) => t("click:append")),
                color: "inherit",
                height: `${n.iconHeight}px`,
                icon: s.$attrs["append-icon"]
              }, null, 8, ["height", "icon"])) : I("", !0)
            ])
          } : void 0,
          s.$attrs["append-inner-icon"] ? {
            name: "append-inner",
            fn: p(() => [
              typeof s.$attrs["append-inner-icon"] == "string" ? (f(), y(u(O), {
                key: 0,
                class: "v-icon--clickable",
                onClick: l[1] || (l[1] = ($) => t("click:appendInner")),
                color: "inherit",
                height: `${n.iconHeight}px`,
                icon: s.$attrs["append-inner-icon"]
              }, null, 8, ["height", "icon"])) : I("", !0)
            ])
          } : void 0,
          s.$attrs["prepend-icon"] ? {
            name: "prepend",
            fn: p(() => [
              typeof s.$attrs["prepend-icon"] == "string" ? (f(), y(u(O), {
                key: 0,
                class: "v-icon--clickable",
                onClick: l[2] || (l[2] = ($) => t("click:prepend")),
                color: "inherit",
                height: `${n.iconHeight}px`,
                icon: s.$attrs["prepend-icon"]
              }, null, 8, ["height", "icon"])) : I("", !0)
            ])
          } : void 0,
          s.$attrs["prepend-inner-icon"] ? {
            name: "prepend-inner",
            fn: p(() => [
              typeof s.$attrs["prepend-inner-icon"] == "string" ? (f(), y(u(O), {
                key: 0,
                class: "v-icon--clickable",
                onClick: l[3] || (l[3] = ($) => t("click:prependInner")),
                color: "inherit",
                height: `${n.iconHeight}px`,
                icon: s.$attrs["prepend-inner-icon"]
              }, null, 8, ["height", "icon"])) : I("", !0)
            ])
          } : void 0
        ]), 1040, ["rules", "label"])
      ]),
      _: 1
    }, 8, ["class"]));
  }
});
const p0 = /* @__PURE__ */ G(f0, [["__scopeId", "data-v-fd53d522"]]), h0 = /* @__PURE__ */ w({
  props: {
    placeholder: {
      type: String,
      default: "Search"
    },
    modelValue: {
      type: String,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e;
    return (d, r) => (f(), y(je, B(d.$attrs, {
      "hide-details": "auto",
      class: "c-input",
      placeholder: n.placeholder,
      density: "compact",
      variant: "plain",
      "model-value": e.modelValue,
      "onUpdate:modelValue": r[0] || (r[0] = (o) => t("update:modelValue", o))
    }), null, 16, ["placeholder", "model-value"]));
  }
});
const y0 = /* @__PURE__ */ G(h0, [["__scopeId", "data-v-8b370477"]]), g0 = (e) => {
  switch (e) {
    case de.COMPACT:
      return "60px";
    case de.COMFORTABLE:
      return "68px";
    default:
      return "76px";
  }
}, m0 = /* @__PURE__ */ w({
  props: {
    rules: {
      type: Array,
      default: () => []
    },
    iconHeight: {
      type: String,
      default: "16"
    },
    noPadding: {
      type: Boolean,
      default: !0
    },
    noMargin: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "click:append",
    "click:appendInner",
    "click:prepend",
    "click:prependInner"
  ],
  setup(e, { emit: t }) {
    const n = e, { textfieldRules: d } = Ee(n.rules);
    return (r, o) => (f(), y(u(Mn), {
      class: A([
        "c-input",
        {
          "c-input--small-font": r.$attrs.density === u(de).COMPACT
        },
        {
          "c-input--disabled": r.$attrs.disabled === "" || r.$attrs.disabled === !0
        }
      ]),
      style: nd({
        height: u(d).length && u(g0)(r.$attrs.density) || "auto"
      })
    }, {
      default: p(() => [
        D(u(je), B(r.$attrs, {
          "hide-details": "auto",
          rules: u(d),
          "bg-color": "aphla-bg",
          color: "button-primary"
        }), re({ _: 2 }, [
          r.$attrs["append-icon"] ? {
            name: "append",
            fn: p(() => [
              typeof r.$attrs["append-icon"] == "string" ? (f(), y(u(O), {
                key: 0,
                class: "v-icon--clickable",
                onClick: o[0] || (o[0] = (i) => t("click:append")),
                color: "inherit",
                height: `${n.iconHeight}px`,
                icon: r.$attrs["append-icon"]
              }, null, 8, ["height", "icon"])) : I("", !0)
            ])
          } : void 0,
          r.$attrs["append-inner-icon"] ? {
            name: "append-inner",
            fn: p(() => [
              typeof r.$attrs["append-inner-icon"] == "string" ? (f(), y(u(O), {
                key: 0,
                class: "v-icon--clickable",
                onClick: o[1] || (o[1] = (i) => t("click:appendInner")),
                color: "inherit",
                height: `${n.iconHeight}px`,
                icon: r.$attrs["append-inner-icon"]
              }, null, 8, ["height", "icon"])) : I("", !0)
            ])
          } : void 0,
          r.$attrs["prepend-icon"] ? {
            name: "prepend",
            fn: p(() => [
              typeof r.$attrs["prepend-icon"] == "string" ? (f(), y(u(O), {
                key: 0,
                class: "v-icon--clickable",
                onClick: o[2] || (o[2] = (i) => t("click:prepend")),
                color: "inherit",
                height: `${n.iconHeight}px`,
                icon: r.$attrs["prepend-icon"]
              }, null, 8, ["height", "icon"])) : I("", !0)
            ])
          } : void 0,
          r.$attrs["prepend-inner-icon"] ? {
            name: "prepend-inner",
            fn: p(() => [
              typeof r.$attrs["prepend-inner-icon"] == "string" ? (f(), y(u(O), {
                key: 0,
                class: "v-icon--clickable",
                onClick: o[3] || (o[3] = (i) => t("click:prependInner")),
                color: "inherit",
                height: `${n.iconHeight}px`,
                icon: r.$attrs["prepend-inner-icon"]
              }, null, 8, ["height", "icon"])) : I("", !0)
            ])
          } : void 0
        ]), 1040, ["rules"])
      ]),
      _: 1
    }, 8, ["class", "style"]));
  }
});
const M0 = /* @__PURE__ */ G(m0, [["__scopeId", "data-v-b5ff272d"]]), b0 = /* @__PURE__ */ w({
  props: {
    placeholder: {
      type: String,
      default: "Search"
    },
    modelValue: {
      type: String,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e;
    return (d, r) => (f(), y(u(je), B(d.$attrs, {
      "hide-details": "auto",
      placeholder: n.placeholder,
      variant: "outlined",
      "bg-color": "aphla-bg",
      color: "button-primary",
      density: "compact",
      "model-value": e.modelValue,
      class: [
        "c-input",
        {
          "c-input--small-font": d.$attrs.density === u(de).COMPACT
        }
      ],
      "onUpdate:modelValue": r[1] || (r[1] = (o) => t("update:modelValue", o))
    }), {
      "prepend-inner": p(() => [
        D(u(O), {
          class: "search-icon",
          color: "inherit",
          height: 20,
          icon: "ph:magnifying-glass"
        })
      ]),
      clear: p(() => [
        D(u(O), {
          class: "x-icon",
          color: "inherit",
          height: 20,
          icon: "ph:x",
          onClick: r[0] || (r[0] = (o) => t("update:modelValue", ""))
        })
      ]),
      _: 1
    }, 16, ["placeholder", "model-value", "class"]));
  }
});
const v0 = /* @__PURE__ */ G(b0, [["__scopeId", "data-v-da21a0a1"]]), V0 = /* @__PURE__ */ w({
  props: {
    mode: {
      type: String,
      default: Qn.OUTLINED
    }
  },
  setup(e) {
    const t = e, n = {
      plain: y0,
      search: v0,
      outlined: p0,
      primary: M0
    };
    return (d, r) => (f(), y(ee(n[t.mode]), J(q(d.$attrs)), {
      default: p(() => [
        S(d.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
const N0 = /* @__PURE__ */ w({
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e;
    return (d, r) => (f(), y(sd, B({
      class: { overlay: n.loading },
      density: "compact",
      flat: "",
      "hide-details": "",
      inset: "",
      "model-value": e.modelValue
    }, { ...d.$attrs }, {
      "onUpdate:modelValue": r[0] || (r[0] = (o) => d.$emit("update:modelValue", o))
    }), null, 16, ["class", "model-value"]));
  }
});
const I0 = /* @__PURE__ */ G(N0, [["__scopeId", "data-v-b025e8ba"]]);
var Yn = /* @__PURE__ */ ((e) => (e.INSET = "inset", e))(Yn || {});
const G0 = /* @__PURE__ */ w({
  props: {
    mode: {
      type: String,
      default: Yn.INSET
    }
  },
  setup(e) {
    const t = e, n = {
      inset: I0
    };
    return (d, r) => (f(), y(ee(n[t.mode]), J(q(d.$attrs)), re({ _: 2 }, [
      he(Object.keys(d.$slots), (o) => ({
        name: o,
        fn: p((i) => [
          S(d.$slots, o, J(q(i)))
        ])
      }))
    ]), 1040));
  }
});
var L = /* @__PURE__ */ ((e) => (e.LILAC = "lilac", e.BERRY = "berry", e.CAMERA = "camera", e.PREMIUM = "premium", e.BLUE = "blue", e.GREEN = "green", e.PINK = "pink", e.ERROR = "error", e))(L || {});
const C0 = (e) => (pn("data-v-26f08c07"), e = e(), hn(), e), O0 = {
  key: 0,
  class: "d-flex mr-1"
}, D0 = /* @__PURE__ */ C0(() => /* @__PURE__ */ j("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ j("path", {
    d: "M2.14004 2.14004L6 0.541196L9.85996 2.14004L11.4588 6L9.85996 9.85996L6 11.4588L2.14004 9.85996L0.541196 6L2.14004 2.14004Z",
    fill: "#F3C70D",
    stroke: "white"
  }),
  /* @__PURE__ */ j("path", {
    d: "M7.14537 4.36365V5.1307H4.72644V4.36365H7.14537ZM5.32364 3.35554H6.31532V7.30582C6.31532 7.43914 6.33541 7.54141 6.37559 7.61264C6.41759 7.68204 6.47238 7.72952 6.53996 7.75509C6.60753 7.78066 6.68241 7.79344 6.76459 7.79344C6.82668 7.79344 6.8833 7.78888 6.93444 7.77975C6.9874 7.77062 7.02758 7.7624 7.05497 7.75509L7.22208 8.53036C7.16912 8.54862 7.09332 8.56871 6.9947 8.59062C6.89791 8.61254 6.7792 8.62532 6.63858 8.62898C6.3902 8.63628 6.16648 8.59884 5.96741 8.51666C5.76834 8.43265 5.61037 8.30298 5.49349 8.12766C5.37843 7.95233 5.32181 7.73318 5.32364 7.47019V3.35554Z",
    fill: "#E9AD03"
  })
], -1)), w0 = [
  D0
], T0 = { key: 2 }, H0 = /* @__PURE__ */ w({
  props: {
    icon: {
      type: String,
      default: ""
    },
    mode: {
      type: String,
      default: L.LILAC
    }
  },
  setup(e) {
    const t = () => L.BERRY || L.CAMERA ? "cta" : "highlight-color";
    return (n, d) => (f(), C("div", {
      class: A([
        "align-center d-flex tag",
        { "tag--no-icon": !e.icon && e.mode !== u(L).PREMIUM },
        { "tag--lilac": e.mode === u(L).LILAC || e.mode === u(L).PREMIUM },
        { "tag--berry": e.mode === u(L).BERRY },
        { "tag--camera": e.mode === u(L).CAMERA },
        { "tag--blue": e.mode === u(L).BLUE },
        { "tag--green": e.mode === u(L).GREEN },
        { "tag--pink": e.mode === u(L).PINK },
        { "tag--error": e.mode === u(L).ERROR }
      ])
    }, [
      e.mode === u(L).PREMIUM ? (f(), C("div", O0, w0)) : e.icon ? (f(), y(u(O), {
        key: 1,
        height: "12",
        class: "mr-1",
        icon: e.icon,
        color: `rgb(var(--v-theme-${t}))`
      }, null, 8, ["icon", "color"])) : I("", !0),
      e.mode === u(L).PREMIUM ? (f(), C("span", T0, "PREMIUM")) : S(n.$slots, "default", { key: 3 }, void 0, !0)
    ], 2));
  }
});
const j0 = { class: "bottom-wrapper bottom-wrapper--right d-flex justify-center" }, A0 = {
  key: 0,
  class: "align-center d-flex flex-column justify-center loading-card py-5"
}, S0 = { class: "align-center d-flex justify-center loading-card__wrapper pa-2" }, x0 = /* @__PURE__ */ w({
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Type your text"
    },
    rules: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: "180px"
    },
    fullHeight: {
      type: Boolean,
      default: !1
    },
    maxHeight: {
      type: String,
      default: "180px"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    loadingTitle: {
      type: String,
      default: "Generating..."
    },
    loadingText: {
      type: String,
      default: "please wait"
    },
    testId: {
      type: String,
      default: ""
    },
    max: {
      type: Number,
      default: 180
    },
    label: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e;
    dd((c) => ({
      e9f4898c: u(s),
      "7a733ba8": u(a)
    }));
    const d = Y(!1), r = Y(null), o = Y(0), { textfieldRules: i } = Ee(n.rules), a = R(() => n.maxHeight);
    Te(() => {
      $t("textarea", n.testId);
      const c = document.querySelector("textarea.v-field__input");
      c && (r.value = c), l(), r.value.addEventListener("input", l);
    }), rd(() => {
      document.removeEventListener("input", l);
    });
    const s = R(() => n.fullHeight || r.value === null ? n.height : (parseInt(n.height) > o.value, o.value + "px")), l = () => {
      r.value && (o.value = r.value.scrollHeight);
    }, $ = () => {
      t("update:modelValue", "");
    };
    return gn(
      () => n.modelValue,
      () => {
        o.value = (r == null ? void 0 : r.value).scrollHeight;
      }
    ), (c, h) => (f(), C("div", {
      class: A([
        "wrapper",
        { "wrapper--border": !d.value },
        { "wrapper--filled": e.modelValue.length && !d.value },
        { "wrapper--error": e.modelValue.length > e.max },
        { "wrapper--disabled": c.$attrs.disabled === "" || c.$attrs.disabled === !0 }
      ])
    }, [
      D(ld, B({ ref: "field" }, c.$attrs, {
        class: [
          "c-textarea",
          `c-textarea-${n.testId}`,
          { "c-textarea__append-inner": !!c.$slots["append-inner"] },
          { "c-textarea--label": e.label }
        ],
        placeholder: e.placeholder,
        "model-value": n.modelValue,
        rules: u(i),
        variant: "solo",
        "onUpdate:focused": h[0] || (h[0] = (g) => d.value = g),
        "onUpdate:modelValue": h[1] || (h[1] = (g) => t("update:modelValue", g)),
        label: e.label,
        "hide-details": "auto",
        "auto-grow": "",
        clearable: "",
        "persistent-clear": d.value
      }), {
        clear: p(() => [
          D(u(O), {
            icon: "ph:x-circle-fill",
            height: "18",
            width: "18",
            color: "rgb(var(--v-theme-copy-tertiary))",
            onClick: $
          })
        ]),
        counter: p(() => [
          e.modelValue.length > e.max ? (f(), y(k, {
            key: 0,
            variant: "body-2-500",
            "color-class": "error"
          }, {
            default: p(() => [
              P(T(e.modelValue.length + "/" + e.max), 1)
            ]),
            _: 1
          })) : (f(), y(k, {
            key: 1,
            variant: "body-2-500",
            "color-class": "button-primary"
          }, {
            default: p(() => [
              P(T(e.modelValue.length + "/" + e.max), 1)
            ]),
            _: 1
          }))
        ]),
        _: 1
      }, 16, ["class", "placeholder", "model-value", "rules", "label", "persistent-clear"]),
      j("div", j0, [
        S(c.$slots, "btm", {}, void 0, !0)
      ]),
      e.loading ? (f(), C("div", A0, [
        j("div", S0, [
          D(u(ud), {
            class: "loading-card__loader",
            indeterminate: "",
            size: "48",
            width: "5",
            color: "rgb(var(--v-theme-highlight-color))",
            "bg-color": "rgb(var(--v-theme-universal-gray))"
          })
        ]),
        D(k, {
          variant: "subtitle-2-600",
          class: "mt-4"
        }, {
          default: p(() => [
            P(T(e.loadingTitle), 1)
          ]),
          _: 1
        }),
        D(k, {
          "color-class": "copy-secondary",
          variant: "body-2-300",
          class: "mt-1"
        }, {
          default: p(() => [
            P(T(e.loadingText), 1)
          ]),
          _: 1
        })
      ])) : I("", !0)
    ], 2));
  }
});
const E0 = /* @__PURE__ */ G(x0, [["__scopeId", "data-v-dca121cd"]]);
var Vn = /* @__PURE__ */ ((e) => (e.OUTLINED = "outlined", e))(Vn || {});
const W0 = /* @__PURE__ */ w({
  props: {
    mode: {
      type: String,
      default: Vn.OUTLINED
    }
  },
  setup(e) {
    const t = e, n = {
      outlined: E0
    };
    return (d, r) => (f(), y(ee(n[t.mode]), J(q(d.$attrs)), re({
      default: p(() => [
        S(d.$slots, "default")
      ]),
      _: 2
    }, [
      he(Object.keys(d.$slots), (o) => ({
        name: o,
        fn: p((i) => [
          S(d.$slots, o, J(q(i)))
        ])
      }))
    ]), 1040));
  }
});
export {
  v as B,
  k as C,
  kn as D,
  O as I,
  P0 as S,
  L as T,
  G as _,
  gr as a,
  Q0 as b,
  z0 as c,
  G0 as d,
  B0 as e,
  R0 as f,
  H0 as g,
  _0 as h,
  U0 as i,
  Y0 as j,
  V0 as k,
  W0 as l,
  F0 as s
};
